import Vue from 'vue'

import { documents as api_documents } from "../../api";

import { client } from "../../api/client";
import { getField, updateField } from 'vuex-map-fields';
import {BASES_LABELS,TAXES_LABELS,DEFAULT_ANNOTATION_LAYER} from '../constants'
import { get_currentCompanyId } from "../../utils/common";
import { setType0metadata } from "../../modules/invoices/domain/Invoice"

import vuetify from '../../plugins/vuetify';

// Types
export const SET_DOC_ID = "SET_DOC_ID";
export const SET_DOC_STATE = "SET_DOC_STATE";

export const RESET_DOC = "RESET_DOC";
export const FETCH_DOC_BEGIN = "FETCH_DOC_BEGIN";
export const FETCH_DOC_ERROR = "FETCH_DOC_ERROR";
export const FETCH_DOC_SUCCESS = "FETCH_DOC_SUCCESS";
export const DOCUMENT_TO_PARAM = "DOCUMENT_TO_PARAM";
export const FETCH_METADATA_SUCCESS = "FETCH_METADATA_SUCCESS";

export const WRITE_DOC_BEGIN = "WRITE_DOC_BEGIN";
export const WRITE_DOC_ERROR = "WRITE_DOC_ERROR";
export const WRITE_DOC_SUCCESS = "WRITE_DOC_SUCCESS";

export const SET_TEXT_TAGGING = "SET_TEXT_TAGGING";

export const CONTINUE_FLOW_BEGIN = "CONTINUE_FLOW_BEGIN";
export const CONTINUE_FLOW_ERROR = "CONTINUE_FLOW_ERROR";
export const CONTINUE_FLOW_SUCCESS = "CONTINUE_FLOW_SUCCESS";

export const SET_SELECTED_LABEL = "SET_SELECTED_LABEL";
export const SET_SELECTED_TEXT = "SET_SELECTED_TEXT";
export const SET_DOC_LABEL = "SET_DOC_LABEL";
export const SET_CURRENT_DOCUMENTS = "SET_CURRENT_DOCUMENTS";
export const SET_CURRENT_INDEX = "SET_CURRENT_INDEX";
export const SET_CURRENT_FILTERS = "SET_CURRENT_FILTERS";

export const SET_CURRENT_OPTIONS = "SET_CURRENT_OPTIONS";
export const SET_CURRENT_LOADING = "SET_CURRENT_LOADING";
export const SET_LOADING_INFO = "SET_LOADING_INFO";
export const SET_DINAMIC_CALL_ID = "SET_DINAMIC_CALL_ID";
export const SET_ITEMS_LENGTH = "SET_ITEMS_LENGTH";

export const SET_DICT_BOOL_STATES = "SET_DICT_BOOL_STATES";
export const SET_DICT_BOOL_TAGS = "SET_DICT_BOOL_TAGS";
export const SET_FILTERS_LOADED = "SET_FILTERS_LOADED";
export const SET_FILTERS_DATA_STATES_VALUES = "SET_FILTERS_DATA_STATES_VALUES";
export const SET_FILTERS_DATA_TAGS_VALUES = "SET_FILTERS_DATA_TAGS_VALUES";
export const SET_MAIN_FILTERS = "SET_MAIN_FILTERS";

export const SET_FILTERS_DATA_EJERCICIO_VALUE = "SET_FILTERS_DATA_EJERCICIO_VALUE";
export const SET_FILTERS_DATA_PROJECT_VALUE = "SET_FILTERS_DATA_PROJECT_VALUE";
export const SET_FILTERS_DATA_ID_VALUE = "SET_FILTERS_DATA_ID_VALUE";
export const SET_FILTERS_DATA_STATE_VALUE = "SET_FILTERS_DATA_STATE_VALUE";
export const SET_FILTERS_DATA_SEARCH_VALUE = "SET_FILTERS_DATA_SEARCH_VALUE";
export const SET_FILTERS_DATA_SEARCH_DUPLICATE_VALUE = "SET_FILTERS_DATA_SEARCH_DUPLICATE_VALUE";
export const SET_FILTERS_DATA_TAGS_VALUE = "SET_FILTERS_DATA_TAGS_VALUE";
export const SET_FILTERS_DATA_ENTRY_NUMBER_VALUE = "SET_FILTERS_DATA_ENTRY_NUMBER_VALUE";
export const SET_FILTERS_DATA_ACCOUNT_MOVE_NUMBER_VALUE = "SET_FILTERS_DATA_ACCOUNT_MOVE_NUMBER_VALUE";
export const SET_FILTERS_DATA_KEY = 'SET_FILTERS_DATA_KEY';
export const SET_FILTERS_DATA_ACTIVIDAD_STR_VALUES = 'SET_FILTERS_DATA_ACTIVIDAD_STR_VALUES';
export const SET_FILTERS_DATA_ACTIVIDAD_VALUES = 'SET_FILTERS_DATA_ACTIVIDAD_VALUES'

export const SET_IS_TRAINER_MODE = "SET_IS_TRAINER_MODE";
export const SET_IS_DEBUGGER_MODE = "SET_IS_DEBUGGER_MODE";
export const SET_FORCED_MOVE = "SET_FORCED_MOVE";
export const SET_ACCOUNT_MOVES = "SET_ACCOUNT_MOVES";

export const SET_CHECK_SUM = "SET_CHECK_SUM;"
export const SET_CURRENT_DOCUMENT_CUSTOMERDB = "SET_CURRENT_DOCUMENT_CUSTOMERDB";
export const SET_CURRENT_DOCUMENT_SUPPLIERDB = "SET_CURRENT_DOCUMENT_SUPPLIERDB";
export const SET_ANNOTATION_LAYER = "SET_ANNOTATION_LAYER";

export const SET_ZOOM = "SET_ZOOM";
export const SET_ROTATION = "SET_ROTATION";
export const SET_ROTATION_MODE = "SET_ROTATION_MODE";
export const SET_GLOBAL_ROTATION = "SET_GLOBAL_ROTATION";
export const SET_DOCUMENT_ROTATION = "SET_DOCUMENT_ROTATION";
export const CANCEL_ROTATION = "CANCEL_ROTATION";
export const SET_ROTATION_TASK = "SET_ROTATION_TASK";

export const SET_INTRA_DATA_FROM_SUPPLIER = "SET_INTRA_DATA_FROM_SUPPLIER";
export const SET_IVA_0_FROM_TO = "SET_IVA_0_FROM_TO";
export const SET_INTRA_DATA_FROM_CUSTOM = "SET_INTRA_DATA_FROM_CUSTOM";
export const SET_DIRTY = "SET_DIRTY";
export const SET_ITEMS_PER_PAGE = "SET_ITEMS_PER_PAGE";
export const SET_DOCUMENTS_LIST_HEADERS = "SET_DOCUMENTS_LIST_HEADERS";
export const SET_DOCUMENT_LIST_HIDDEN_HEADERS = "SET_DOCUMENT_LIST_HIDDEN_HEADERS";
export const SET_DOCUMENTS_LIST_HEADERS_READ_ONLY = "SET_DOCUMENTS_LIST_HEADERS_READ_ONLY";
export const SET_DOCUMENT_LIST_HIDDEN_HEADERS_READ_ONLY = "SET_DOCUMENT_LIST_HIDDEN_HEADERS_READ_ONLY";
export const SET_DOCUMENTS_LIST_HEADERS_USER = "SET_DOCUMENTS_LIST_HEADERS_USER";
export const SET_DOCUMENT_LIST_HIDDEN_HEADERS_USER = "SET_DOCUMENT_LIST_HIDDEN_HEADERS_USER";
export const SET_SUPPLIERDB_LIST_HEADERS_USER = "SET_SUPPLIERDB_LIST_HEADERS_USER";
export const SET_SUPPLIERDB_LIST_HIDDEN_HEADERS_USER = "SET_SUPPLIERDB_LIST_HIDDEN_HEADERS_USER";
export const SET_CUSTOMERDB_LIST_HEADERS_USER = "SET_CUSTOMERDB_LIST_HEADERS_USER";
export const SET_CUSTOMERDB_LIST_HIDDEN_HEADERS_USER = "SET_CUSTOMERDB_LIST_HIDDEN_HEADERS_USER";
export const REMOVE_DOCUMENTS_LIST_HEADERS_ELEM_BY_INDEX = "REMOVE_DOCUMENTS_LIST_HEADERS_ELEM_BY_INDEX";
export const SET_DOCUMENTS_LIST_HEADERS_ELEM = "SET_DOCUMENTS_LIST_HEADERS_ELEM";
export const CLEAN_FILTERS = "CLEAN_FILTERS";
export const SET_DOCUMENT_OPTIONS_PAGE = "SET_DOCUMENT_OPTIONS_PAGE";
export const SET_DOCUMENT_LIST_OPTIONS = "SET_DOCUMENT_LIST_OPTIONS";
export const SET_DOCUMENT_KIND = "SET_DOCUMENT_KIND";
export const SET_STATES_FILTER = "SET_STATES_FILTER";
export const SET_DOCUMENTS_LIST_ID = "SET_DOCUMENTS_LIST_ID";
export const SET_BROWSER_VALUE = "SET_BROWSER_VALUE";

export const UNSELECT_DOCUMENTS = "UNSELECT_DOCUMENTS";
export const SET_CURRENT_PAGE = "SET_CURRENT_PAGE";
export const SET_SELECTED_STATE_CHIP = "SET_SELECTED_STATE_CHIP";
export const SET_DOCUMENT_ACTIONS_ERROR_PARAMS = "SET_DOCUMENT_ACTIONS_ERROR_PARAMS";
export const SET_CRITERIO_DE_CAJA = "SET_CRITERIO_DE_CAJA";
export const SET_IS_COMERCIANTE_MINORISTA = "SET_IS_COMERCIANTE_MINORISTA";
export const SET_PAYMENT_ACCOUNT = 'SET_PAYMENT_ACCOUNT';
export const SET_CHARGE_ACCOUNT = 'SET_CHARGE_ACCOUNT';
export const SET_INV_NUMBER_TO_RECTIFY = 'SET_INV_NUMBER_TO_RECTIFY';
export const SET_INV_DATE_TO_RECTIFY = 'SET_INV_DATE_TO_RECTIFY';

export const SET_ACCOUNT_MOVE_LINES = 'SET_ACCOUNT_MOVE_LINES';
export const SET_LAST_SHOW_ACCOUNT_MOVE = 'SET_LAST_SHOW_ACCOUNT_MOVE'

export const SET_INVOICE_LINES = 'SET_INVOICE_LINES';
export const SET_LAST_SHOW_INVOICE_LINES = 'SET_LAST_SHOW_INVOICE_LINES'

// Barra de filtros nueva
export const SET_FILTER_EJERCICIO = 'SET_FILTER_EJERCICIO';
export const SET_FILTERS_DATA_EJERCICIO_USER_VALUES = "SET_FILTERS_DATA_EJERCICIO_USER_VALUES";
export const SET_FILTER_ID = 'SET_FILTER_ID';
export const SET_FILTER_STATE = 'SET_FILTER_STATE';
export const SET_FILTER_SEARCH_ICONTAINS = 'SET_FILTER_SEARCH_ICONTAINS';
export const SET_FILTER_SEARCH_DUPLICATE = 'SET_FILTER_SEARCH_DUPLICATE';
export const SET_FILTER_DOCUMENT_TEXT_ICONTAINS = 'SET_FILTER_DOCUMENT_TEXT_ICONTAINS';
export const SET_FILTER_TAGS = 'SET_FILTER_TAGS';
export const SET_FILTER_ACTIVIDAD_STR = 'SET_FILTER_ACTIVIDAD_STR';
export const SET_FILTER_ACTIVIDAD = 'SET_FILTER_ACTIVIDAD';
export const SET_FILTER_USERNAME_ICONTAINS = 'SET_FILTER_USERNAME_ICONTAINS';
export const SET_FILTER_KIND = 'SET_FILTER_KIND';
export const SET_FILTER_CREATED_GTE = 'SET_FILTER_CREATED_GTE';
export const SET_FILTER_CREATED_LTE = 'SET_FILTER_CREATED_LTE';
export const SET_FILTER_ACCOUNTING_DATE_GTE = 'SET_FILTER_ACCOUNTING_DATE_GTE';
export const SET_FILTER_ACCOUNTING_DATE_LTE = 'SET_FILTER_ACCOUNTING_DATE_LTE';
export const SET_FILTER_INVOICE_DATE_GTE = 'SET_FILTER_INVOICE_DATE_GTE';
export const SET_FILTER_INVOICE_DATE_LTE = 'SET_FILTER_INVOICE_DATE_LTE';
export const SET_FILTER_THIRD_CIF_ICONTAINS = 'SET_FILTER_THIRD_CIF_ICONTAINS';
export const SET_FILTER_THIRD_NAME_ICONTAINS = 'SET_FILTER_THIRD_NAME_ICONTAINS';
export const SET_FILTER_MIRROR_STATE = 'SET_FILTER_MIRROR_STATE';
export const SET_FILTER_PUNTEADO = 'SET_FILTER_PUNTEADO';
export const SET_FILTER_RECTIFICATIVA = 'SET_FILTER_RECTIFICATIVA';
export const SET_FILTER_PAYMENT_STATE = 'SET_FILTER_PAYMENT_STATE';
export const SET_FILTER_PAYMENT_DATE_GTE = 'SET_FILTER_PAYMENT_DATE_GTE';
export const SET_FILTER_PAYMENT_DATE_LTE = 'SET_FILTER_PAYMENT_DATE_LTE';
export const SET_FILTER_HAS_RETENTION = 'SET_FILTER_HAS_RETENTION';
export const SET_FILTER_NOTES_ICONTAINS = 'SET_FILTER_NOTES_ICONTAINS';


// models
class Document {
  constructor({
    id,
    account_moves,
    binary_file,
    companydb_info,
    companydb_gestion_cartera,
    company_name,
    comment,
    created,
    customerdb,
    customer_name,
    customerdb_info,
    error_json,
    warning_json,
    original_file_name,
    file_name,
    full_file_name,
    kind,
    kind_display,
    metadata,
    metadata_old,
    signed_url,
    state,
    state_display,
    supplierdb,
    supplier_name,
    supplierdb_info,
    tags,
    text_tagging,
    written,
    async_job_state,
    forced_move,
    entry_number,
    accounting_date,
    accounting_date_config,
    default_accounting_date,
    registro_date,
    registro_date_config,
    default_registro_date,
    actividad,
    project,
    channel,
    expens_income_type,
    zoom,
    inRotationMode,
    rotationMode,
    globalRotation,
    rotationPerDocument,
    rotateJobId,
    inversion_sujeto_pasivo_iva,
    inversion_sujeto_pasivo_iva_percent,
    inversion_sujeto_pasivo_igic,
    inversion_sujeto_pasivo_igic_percent,
    intracomunitario,
    intracomunitario_percent,
    intracomunitario_type,
    importaciones_percent,
    extracomunitario,
    iva_igic_no_deducible,
    comerciante_minorista,
    gasto_iva_parcial,
    iva_parcial,
    gasto_iva_percent,
    no_sujeta,
    bien_inversion,
    error,
    payment_account,
    automatic_payment_account,
    charge_account,
    automatic_charge_account,
    has_mirror,
    has_simulated_mirror,
    written_description,
    description,
    punteado,
    paths,
    prorate,
    actividad_str,
    building_code,
    apply_modelo,
    apply_415,
    serie,
    doc_number,
    doc_number_prefix,
    excel_line_index,
    currency,
    retention_type_name,
    criterio_de_caja,
    is_comerciante_minorista,
    inv_number_to_rectify,
    inv_date_to_rectify,
    is_comerciante_minorista_percent,
    written_description_sii,
    description_sii,
    needs_tt_fix,
    notes,
    invoice_lines,
    detected_company_id,
    static_invoice,
    fiscal_location,
    ...rest
  }) {
    this.id = id;
    //this.accountMoves = account_moves?account_moves:[{account_move_lines:[]}];
    this.accountMoves = account_moves
    this.binaryFile = binary_file;
    this.comment = comment;
    this.companydb = companydb_info.id;
    this.companydb_info = companydb_info;
    this.companydb_gestion_cartera = companydb_gestion_cartera;
    this.companyName = company_name;
    this.created = created;
    this.customerdb = customerdb;
    this.customerName = customer_name;
    this.customerdb_info = customerdb_info;
    this.errorJson = error_json;
    this.warningJson = warning_json;
    this.originalFileName = original_file_name;
    this.fileName = file_name;
    this.fullFileName = full_file_name;
    this.kind = kind;
    this.kind_display = kind_display;
    this.invoice_lines = invoice_lines;
    this.metadata = metadata?metadata:{};
    this.metadata_old = metadata_old?JSON.stringify(metadata_old):{};
    this.state = state;
    this.state_display = state_display;
    this.signed_url = signed_url;
    this.supplierdb = supplierdb;
    this.supplierName = supplier_name;
    this.supplierdb_info = supplierdb_info;
    this.tags = tags;
    this.textTagging = text_tagging;
    // this.textTagging.forEach(tag=>{
    //   if(!tag.label){
    //     tag.label={'human':'background','human_payroll':'background'}
    //   }
    // })
    this.written = written;
    this.async_job_state = async_job_state;
    this.forced_move = forced_move;
    this.entry_number = entry_number;
    this.accounting_date = accounting_date;
    this.accounting_date_config = accounting_date_config;
    if(!this.accounting_date_config){
      this.accounting_date_config = 'invoice_date'
    }
    this.default_accounting_date = default_accounting_date;
    this.registro_date = registro_date;
    this.registro_date_config = registro_date_config;
    if(!this.registro_date_config){
      this.registro_date_config = 'today'
    }
    this.default_registro_date = default_registro_date;
    this.actividad = actividad;
    this.project = project;
    this.channel = channel;
    this.expens_income_type = expens_income_type;
    this.zoom = zoom;
    this.inRotationMode = inRotationMode;
    this.rotationMode = rotationMode;
    this.globalRotation = globalRotation;
    this.rotationPerDocument = rotationPerDocument;
    this.rotateJobId = rotateJobId;

    this.inversion_sujeto_pasivo_iva = inversion_sujeto_pasivo_iva
    this.inversion_sujeto_pasivo_iva_percent = inversion_sujeto_pasivo_iva_percent
    this.inversion_sujeto_pasivo_igic = inversion_sujeto_pasivo_igic
    this.inversion_sujeto_pasivo_igic_percent = inversion_sujeto_pasivo_igic_percent
    this.intracomunitario = intracomunitario
    this.intracomunitario_percent = intracomunitario_percent
    this.intracomunitario_type = intracomunitario_type
    this.extracomunitario = extracomunitario
    this.importaciones_percent = importaciones_percent
    this.iva_igic_no_deducible = iva_igic_no_deducible
    this.gasto_iva_parcial = gasto_iva_parcial
    this.iva_parcial = iva_parcial
    this.no_sujeta = no_sujeta
    this.bien_inversion = bien_inversion
    this.comerciante_minorista = comerciante_minorista
    this.gasto_iva_percent = gasto_iva_percent
    this.error = error
    this.automatic_payment_account = automatic_payment_account
    this.payment_account = payment_account
    this.automatic_charge_account = automatic_charge_account
    this.charge_account = charge_account
    this.has_mirror = has_mirror
    this.has_simulated_mirror = has_simulated_mirror
    this.written_description = written_description
    this.description = description
    this.punteado = punteado
    this.paths = paths
    this.prorate = prorate
    this.actividad_str = actividad_str
    this.building_code = building_code
    this.apply_modelo = apply_modelo
    this.apply_415 = apply_415;
    this.serie = serie
    this.doc_number = doc_number  
    this.doc_number_prefix = doc_number_prefix
    this.excel_line_index = excel_line_index
    this.currency = currency
    this.retention_type_name = retention_type_name;
    this.criterio_de_caja = criterio_de_caja;
    this.is_comerciante_minorista = is_comerciante_minorista;
    this.inv_number_to_rectify = inv_number_to_rectify;
    this.inv_date_to_rectify = inv_date_to_rectify;
    this.is_comerciante_minorista_percent = is_comerciante_minorista_percent;
    this.written_description_sii = written_description_sii;
    this.description_sii = description_sii;
    this.needs_tt_fix = needs_tt_fix;
    this.notes = notes;
    if(!this.notes){
      this.notes = ''
    }
    this.detected_company_id = detected_company_id;
    this.static_invoice = static_invoice;
    this.fiscal_location = fiscal_location;
  }
}

const models = {
  Document
};

// initial state
const state = () => ({
  id: undefined,
  document: undefined,
  annotationLayer: DEFAULT_ANNOTATION_LAYER,
  documents: {results:[],next:null,previous:null},
  docLoading: false,
  docError: false,
  docWriteLoading: false,
  docWriteError: false,
  flowLoading: false,
  flowError: false,
  index:0,
  selectedLabel: undefined,
  selectedText: undefined,
  docState: undefined,
  loading: false,
  loading_info: '',
  dinamic_call_id:'',
  checkSumOK: true,
  documentMainFilters:[],
  selectedStateChip: 'all',
  dirty: false,
  selectedIvaCheck: undefined,
  currentPage:1,
  documentListHeaders:[
  ],
  documentListHiddenHeaders: [],
  documentListHeadersReadOnly: [],
  documentListHiddenHeadersReadOnly: [],
  documentListHeadersUser: [],
  documentListHiddenHeadersUser: [],
  supplierdbListHeadersUser: [],
  supplierdbListHiddenHeadersUser: [],
  customerdbListHeadersUser: [],
  customerdbListHiddenHeadersUser: [],
  documentListActionGroups: {
    'download': 'Descargas',
    'massive': 'Acciones Masivas',
    'state': 'Cambios de estado',
    'punteado': 'Punteo',
    'other': 'Otros'
  },
  documentListAction: [
    // , 'show_params': 'addMarkAsErrorAccountConnectorAction'
    {'id': 'multi_continue_flow', 'name': 'Reintentar', 'group': 'action', /**'icon': 'mdi-file-restore'*/},
    {'id': 'contabilizar', 'name': 'Contabilizar', 'group': 'btn', /**'icon': 'mdi-file-move',*/ 'not_param': 'contabilize_on_csv'},
    {'id': 'transferir', 'name': 'Transferir', 'group': 'btn', /**'icon': 'mdi-file-move',*/ 'not_param': 'contabilize_on_csv'},
    {'id': 'download_cdb_csv', 'name': 'Descargar', 'group': 'btn', /**'icon': 'mdi-file-move',*/ 'not_param': 'contabilize_on_csv'},
    {'id': 'download_csv_one_line', 'name': 'Descargar CSV', 'group': 'icon_btn', 'icon': 'mdi-file-excel', 'show_params': 'contabilizar_con_csv'},
    // {'id': 'download_csv','name': 'Descargar CSV multilínea', 'group': 'btn'},
    {'id': 'to_done', 'name': 'Contabilizar las facturas del CSV', 'group': 'action', 'show_params': 'contabilizar_con_csv'},
    {'id': 'delete_doc', 'name': 'Borrar Documentos', 'group': 'action', 'icon': 'mdi-delete'},
    {'id': 'merge_docs', 'name': 'Unir Documentos', 'group': 'action'},
    {'id': 'split_docs', 'name': 'Separar Páginas', 'group': 'action'},
    {'id': 'download_doc', 'name': 'Documentos', 'group': 'download'},
    {'id': 'download_merged_docs', 'name': 'Libro en formato PDF', 'group': 'download'},
    {'id': 'download_excel', 'name': 'Excel', 'group': 'download'},
    {'id': 'change_company_doc', 'name': 'Cambiar Empresa', 'group': 'massive'},
    {'id': 'copy_doc_to_other_company', 'name': 'Copiar en otra Empresa', 'group': 'massive', 'feature': 'feature_copy_to_other_company'},
    {'id': 'massive_third_change', 'name': 'Asignar Tercero', 'group': 'massive', 'feature': 'feature_massive_changes_action'},
    {'id': 'massive_change', 'name': 'Cambios Masivos', 'group': 'massive', 'feature': 'feature_massive_changes_action'},
    {'id': 'massive_rotation', 'name': 'Rotar documentos', 'group': 'massive', 'feature': 'feature_can_do_massive_rotation'},
    {'id': 'massive_calculate_base_cuota', 'name': 'Calcular Base y Cuota de forma masiva', 'group': 'massive', 'feature': 'feature_recalculate_base_cuota'},
    {'id': 'accounting_payment_move', 'name': 'Contabilizar asientos de pago', 'group': 'massive', 'feature': 'feature_accounting_payment_move', 'company_automatic_accounts': true},
    {'id': 'massive_fix_round', 'name': 'Redondeo masivo a 2 decimales', 'group': 'massive', 'feature': 'feature_massive_fix_round_action'},
    {'id': 'massive_fix_mismatch_ex0', 'name': 'Descuadre a Ex 0% Masivo', 'group': 'massive', 'feature': 'feature_massive_fix_mismatch_ex0'},
    {'id': 'massive_force_send_documents', 'name': 'Forzar envio documentos', 'group': 'massive', 'feature': 'feature_diezsoftware_massive_force_send_documents'},
    {'id': 'simulate_doc', 'name': 'Simular Documentos', 'group': 'action', 'can_see_training_documents': true},
    {'id': 'add_tags_doc', 'name': 'Añadir Tags', 'group': 'action', 'is_staff': true},
    {'id': 'create_training_doc', 'name': 'Crear Documentos Training', 'group': 'action', 'is_staff': true, 'loginas': true},
    {'id': 'back_pending_upload_to_pending_review', 'name': 'Pdte. Carga --> Pdte. de revisión', 'group': 'state', 'show_params': 'contabilizar_con_csv'},
    {'id': 'change_state_pending_review_to_done', 'name':'Pdte. Revisión --> Contabilizado', 'group': 'state', 'feature': 'feature_pending_review_to_done', 'is_staff': true, 'loginas': true,},
    {'id': 'mark_as_pending_review', 'name': 'Pdte. de sinc. --> Pdte. de revisión', 'group': 'state', 'feature': 'feature_can_mark_doc_as_pending_review', 'is_staff': true, 'loginas': true,},
    {'id': 'mark_as_error_account_connector', 'name': 'Pdte. de sinc. --> Error de contabilización', 'group': 'state', 'show_params': 'addMarkAsErrorAccountConnectorAction', 'is_staff': true, 'loginas': true,},
    {'id': 'change_state_pending_sync_to_done', 'name': 'Pdte. de sinc. --> Contabilizado', 'group': 'state', 'feature': 'feature_pending_sync_to_done', 'is_staff': true, 'loginas': true,},
    {'id': 'change_state_pending_connect_to_pending_review', 'name': 'Contabilizando --> Pdte. de revisión', 'group': 'state', 'is_staff': true, 'loginas': true},
    {'id': 'docs_accounting_to_pending_review', 'name': 'Contabilizando... --> Pdte. de revisión', 'group': 'state', 'is_staff': true, 'feature': 'feature_accounting_to_pending_review'},
    {'id': 'change_state_accounting_to_pending_connect', 'name':'Contabilizando... --> Contabilizando', 'group': 'state', 'is_staff': true, 'loginas': true},
    {'id': 'change_state_accounting_to_pending_sync', 'name':'Contabilizando... --> Pdte. de sincro.', 'group': 'state', 'feature': 'feature_forced_pending_sync', 'is_staff': true, 'loginas': true},
    {'id': 'change_state_accounting_to_done', 'name': 'Contabilizando... --> Contabilizado', 'group': 'state', 'is_staff': true, 'loginas': true},
    {'id': 'bck_doc_pending_review_state', 'name': 'Contabilizado --> Pdte. de revisión', 'group': 'state', 'is_staff': true, 'loginas': true, 'feature': 'feature_can_back_docs_to_pending_review'},
    {'id': 'change_state_to_done_manually', 'name':'Contabilizado Manualmente', 'group': 'state', 'is_staff': true, 'loginas': true, 'feature': 'feature_state_done_manually'},
    {'id': 'force_docs_state_to_done', 'name': 'Error de contabilización --> Contabilizado', 'group': 'state', 'feature': 'feature_can_force_docs_to_done', 'is_staff': true, 'loginas': true,},
    {'id': 'change_state_error_already_destination_to_done', 'name': 'Error: Ya existente en destino --> Contabilizado', 'group': 'state', 'feature': 'feature_error_already_destination_to_done', 'is_staff': true, 'loginas': true,},
    {'id': 'change_state_error_already_destination_to_pending_review', 'name': 'Error: Ya existente en destino --> Pdte. Revisión', 'group': 'state', 'feature': 'feature_error_already_destination_to_pending_review','is_staff': true, 'loginas': true,},
    {'id': 'mark_as_punteado', 'name': 'Marcar', 'group': 'punteado', 'feature': 'feature_can_mark_doc_as_punteado'},
    {'id': 'mark_as_despunteado', 'name': 'Desmarcar', 'group': 'punteado', 'feature': 'feature_can_mark_doc_as_punteado'},
    {'id': 'fix_contasol_documents', 'name': 'Subir PDFs a Contasol', 'group': 'other', 'is_staff': true, 'loginas': true, 'show_params': 'fix_contasol_documents', 'feature': 'feature_fix_contasol_documents'},
    {'id': 'multi_retry_all','name': 'Reintentar detección', 'group': 'other'},
    {'id': 'replicate_doc_to_other_company', 'name': 'Replicar facturas en otra empresa', 'group': 'massive', 'feature': 'feature_replicate_to_other_company'},

  ],

  documentActionsErrorParams: {},

  action: '',
  documentAction: [
    {'id': 'copy_id', 'name': 'Copiar ID'},
    {'id': 'rotate_doc', 'name': 'Rotar Documento'},
    {'id': 'split_doc','name': 'Separar Páginas'},
    {'id': 'change_company_doc','name': 'Cambiar Empresa'},
    {'id': 'simulate_doc', 'name': 'Simular Documento'},
    {'id': 'mark_as_pending_review', 'name': 'Pasar de estado Pdte. de sinc. a Pdte. de revisión'},
    {'id': 'force_docs_state_to_done', 'name': 'Pasar de estado Error de contabilización a Contabilizado'},
    {'id': 'add_tags_doc', 'name': 'Añadir Tags'},
    {'id': 'create_training_doc', 'name': 'Crear Documento Training'},
    {'id': 'check_document_history', 'name': 'Consultar Historial'},
  ],

  // documentListFiltersData: [
  //   {
  //     'name': 'id', 
  //     'label': 'Id',
  //     'value': '',
  //   }, 
  //   {
  //     'name': 'state', 
  //     'label': 'Estado', 
  //     'values':[],
  //     'multiple': false,
  //     'value': '',
  //   },
  //   {
  //     'name': 'search__icontains',
  //     'label': 'Todos los campos',
  //     'value': '',
  //   },
  //   {
  //     'name': 'tags',
  //     'label': 'Etiquetas',
  //     'values': [],
  //     'multiple': true,
  //     'value': '',
  //   },
  //   // {
  //   //   'name': 'entry_number__icontains',
  //   //   'label': 'Apunte',
  //   //   'value': '',
  //   // },
  //   // {
  //   //   'name': 'account_move_number__icontains',
  //   //   'label': 'Asiento',
  //   //   'value': '',
  //   // }
  //   {
  //     'name': 'username__icontains',
  //     'label': 'Usuario',
  //     'value': ''
  //   },
  //   {
  //     'name': 'kind',
  //     'label': 'Tipo',
  //     'values': [
  //       {name: 'Proveedor', value: 'in_invoice'},
  //       {name: 'Cliente', value: 'out_invoice'},
  //       // {name: 'Nómina', value: 'payroll'},
  //     ],
  //     'multiple': false,
  //     'value': '',
  //   }
  // ],



  documentListFiltersData2: {
    ejercicio: {
      'name': 'ejercicio',
      'label': 'Ejercicio',
      'value': '',
      'type': 'select',      
      'icon': 'mdi-calendar-month-outline',
    },
    project: {
      'name': 'project',
      'label': 'Proyecto',
      'value': '',
      'type': 'select',      
      'icon': 'mdi-file-document',
    },
    id: {
      'name': 'id',
      'label': 'Id',
      'value': '',
      'type': 'text',
      'icon': 'mdi-numeric',
    },
    state: {
      'name': 'state',
      'label': 'Estado',
      'values':[],
      'user_values': [
        { value: 'done', text: 'Contabilizado'},
        { value: 'uploading_bucket', text: 'Cargando'},
        { value: 'pending', text: 'En proceso'},
        { value: 'pending_review', text: 'Pendiente de revisión'},
        { value: 'required_review', text: 'Revisión requerida'},
        { value: 'error_supplier_not_found', text: 'Proveedor no encontrado'},
        { value: 'error_customer_not_found', text: 'Cliente no encontrado'},
        { value: 'error_document_duplicated', text: 'Factura duplicada'},
        { value: 'error_checking_taxes', text: 'Error de validación de importes'},
        { value: 'error_creating_moves', text: 'Error de creación de asiento'},
        { value: 'error_account_connector', text: 'Error de contabilización'},
        { value: 'error_validating_moves', text: 'Error de validación de asiento'},
        { value: 'error_validating_data', text: 'Error de validación de datos'},
        { value: 'error_text_detection', text: 'Error de detección de texto'},
        { value: 'error_format', text: 'Error de Formato'},
        { value: 'split', text: 'Separando'},
        { value: 'not_supported', text: 'Formato no soportado'},
        { value: 'merging', text: 'Uniendo documentos'},
      ],
      'multiple': false,
      'value': '',
      'type': 'select',
      'icon': 'mdi-file-chart',
    },
    search__icontains: {
      'name': 'search__icontains',
      'label': 'Todos los campos',
      'value': '',
      'type': 'text',
      'icon': 'mdi-magnify',
    },
    search__duplicate: {
      'name': 'search__duplicate',
      'label': 'Número de factura',
      'value': '',
      'type': 'text',
      'icon': 'mdi-file-document',
    },
    document_text__icontains: {
      'name': 'document_text__icontains',
      'label': 'Texto del Documento',
      'value': '',
      'type': 'text',
      'icon': 'mdi-text-box',
    },
    tags: {
      'name': 'tags',
      'label': 'Etiquetas',
      'values': [],
      'multiple': true,
      'value': '',
      'type': 'select',
      'icon': 'mdi-tag',
    },
    actividad_str: {
      'name': 'actividad_str',
      'label': 'Actividad',
      'values': [],
      'multiple': false,
      'value': '',
      'type': 'text',
      'icon': 'mdi-account-group',
    },
    actividad: {
      'name': 'actividad',
      'label': 'Actividad',
      'values': [],
      'multiple': false,
      'value': '',
      'type': 'text',
      'icon': 'mdi-account-group',
    },
    // {
    //   'name': 'entry_number__icontains',
    //   'label': 'Apunte',
    //   'value': '',
    // },
    // {
    //   'name': 'account_move_number__icontains',
    //   'label': 'Asiento',
    //   'value': '',
    // }
    username__icontains: {
      'name': 'username__icontains',
      'label': 'Usuario',
      'value': '',
      'type': 'text',
      'icon': 'mdi-account',
    },
    kind: {
      'name': 'kind',
      'label': 'Tipo',
      'values': [
        {name: 'Proveedor', value: 'in_invoice', text: 'Proveedor'},
        {name: 'Cliente', value: 'out_invoice', text: 'Cliente'},
        // {name: 'Nómina', value: 'payroll'},
      ],
      'multiple': false,
      'value': '',
      'type': 'select',
      'icon': 'mdi-file-document',
    },

    created__gte: {
      'name': 'created__gte',
      'label': 'F. de subida mín.',
      'value': '',
      'type': 'date',
      'icon': 'mdi-calendar',
    },
    created__lte: {
      'name': 'created__lte',
      'label': 'F. de subida máx.',
      'value': '',
      'type': 'date',
      'icon': 'mdi-calendar',
    },

    accounting_date__gte: {
      'name': 'accounting_date__gte',
      'label': 'F. Contabilización mín.',
      'value': '',
      'type': 'date',
      'icon': 'mdi-calendar',
    },
    accounting_date__lte: {
      'name': 'accounting_date__lte',
      'label': 'F. Contabilización máx.',
      'value': '',
      'type': 'date',
      'icon': 'mdi-calendar',
    },

    invoice_date__gte: {
      'name': 'invoice_date__gte',
      'label': 'F. Factura mín.',
      'value': '',
      'type': 'date',
      'icon': 'mdi-calendar',
    },
    invoice_date__lte: {
      'name': 'invoice_date__lte',
      'label': 'F. Factura máx.',
      'value': '',
      'type': 'date',
      'icon': 'mdi-calendar',
    },
    // metadata__invoice_date__gte: {
    //   'name': 'metadata__invoice_date__gte',
    //   'label': 'Fecha factura mínima',
    //   'value': ''
    // },
    // metadata__invoice_date__lte: {
    //   'name': 'metadata__invoice_date__lte',
    //   'label': 'Fecha factura máxima',
    //   'value': null
    // },
    // metadata__due_date__gte: {
    //   'name': 'metadata__due_date__gte',
    //   'label': 'Fecha vencimiento mínima',
    //   'value': ''
    // },
    // metadata__due_date__lte: {
    //   'name': 'metadata__due_date__lte',
    //   'label': 'Fecha vencimiento máxima',
    //   'value': null
    // },

    third_cif__icontains: {
      'name': 'third_cif__icontains',
      'label': 'Cif de terceros',
      'value': '',
      'type': 'text',
      'icon': 'mdi-card-account-details',
    },
    third_name__icontains: {
      'name': 'third_name__icontains',
      'label': 'Nombre de terceros',
      'value': '',
      'type': 'text',
      'icon': 'mdi-card-account-details',
    },

    mirror_state: {
      'name': 'mirror_state',
      'label': 'Estado del doc. espejo',
      'values':[],
      'multiple': false,
      'value': '',
      'type': 'select',
      'icon': 'mdi-file-chart',
    },
    punteado: {
      'name': 'punteado',
      'label': 'Punteado',
      'values': [
        { name: 'Si', value: 'yes', text: 'Si' },
        { name: 'No', value: 'no', text: 'No' },
      ],
      'multiple': false,
      'value': '',
      'type': 'select',
      'icon': 'mdi-check',
    },
    is_rectificativa: {
      'name': 'is_rectificativa',
      'label': 'Rectificativa',
      'values': [
        { name: 'Si', value: 'yes', text: 'Si' },
        { name: 'No', value: 'no', text: 'No' },
      ],
      'multiple': false,
      'value': '',
      'type': 'select',
      'icon': 'mdi-file-document',
    },
    payment_state: {
      'name': 'payment_state',
      'label': 'Estado de Pago',
      'values': [
        { value: 'pending', name: 'Pendiente', text: 'Pendiente'},
        { value: 'paid', name: 'Pago', text: 'Pago'},
      ],
      'multiple': false,
      'value': '',
      'type': 'select',
      'icon': 'mdi-cash',
    },
    payment_date__gte: {
      'name': 'payment_date__gte',
      'label': 'F. Pago mín. (DD/MM/YYYY)',
      'value': '',
      'type': 'date',
      'icon': 'mdi-calendar',
    },
    payment_date__lte: {
      'name': 'payment_date__lte',
      'label': 'F. Pago máx. (DD/MM/YYYY)',
      'value': '',
      'type': 'date',
      'icon': 'mdi-calendar',
    },
    has_retention: {
      'name': 'has_retention',
      'label': 'Tiene retención',
      'values': [
        { name: 'Si', value: 'yes', text: 'Si' },
        { name: 'No', value: 'no', text: 'No' },
      ],     
      'multiple': false,
      'value': '',
      'type': 'select',
      'icon': 'mdi-cash',
    },
    notes__icontains: {
      'name': 'notes__icontains',
      'label': 'Notas de factura',
      'value': '',
      'type': 'text',
      'icon': 'mdi-note-text',
    }
  },


  documentIsTrainerMode: false,
  documentIsDebuggerMode: false,
  zoom: 0.8,
  inRotationMode: false,
  rotationMode: 'all',
  rotateJobId: undefined,
  globalRotation: 0,
  rotationPerDocument: [],

  statesFilter:undefined,
  documentListLoading: false,
  documentsListFilters: "",
  documentsListState: 'all',
  documentsListId: null,
  documentsListItemsLength: 0,
  documentsListDictBool: {
    'states': false,
    'tags': false
  },
  documentsListFiltersLoaded: false,
  itemsPerPage: 10,

  documentListOptions: {},
  dpcumentListKind: '',
  selectedParam: undefined,
  selectedParamOption: undefined,
  selectedParamOption2: undefined,
  isBienInversionChanged: false,
  areIvaChecksChanged: false,

  metadataFiltersStates: ['done','done_manually','done_with_warning', 'pending_connect', 'accounting_aplifisa_fiscal','accounting_invoice', 'pending_sync', 'pending_review'],
  selected: [],
  linesAccountMove: {
    min_footer: false,
    footer_height: 370,
    last_option: {
      show: false
    }
  },
  invoiceLines: {
    show_invoice_lines: false,
    invoice_lines_height: 370,
    last_option: {
      show: false
    }
  }
})



// getters
const selectedTextPayload = (state, getters) => {
  return (getters.taggedText && getters.selectedText) ? getters.taggedText[getters.currentPage-1][getters.selectedText] : { 'word': '' }
};

const currentDocumentData = (state, getters, rootState, rootGetters) => {
  let result = {};
  let annotationLayer = rootGetters["documents/annotationLayer"];
  getters.taggedText.forEach(page => {
    page.forEach(tagged => {
        let label = tagged.label[annotationLayer];
      if (label != "background") {
        if (label in result) {
          result[label] = `${result[label]} ${tagged.word}`;
        } else {
          result[label] = tagged.word
        }
      }
    })
  })
  return result;
};

const currentHeaders = (state, getters, rootGetters) => {
  if (vuetify.framework.breakpoint.name == 'xs') {
    let headers = [];
    state.documentListHeaders.forEach(function(elem) {
      if (['Tipo', 'Id', 'Num. fra'].includes(elem.text)) {
        headers.push(elem);
      }
    });
    return headers;
  } else {
    state.documentListHeaders.forEach(function(elem) {
      if (!elem.width) {
        elem.width = elem.text.length * 15;
      }
    });
    return state.documentListHeaders;
  }
  
};

const zeroIfNull= (x)=>{
  if(x) return x
  else return 0
}
const sumBasesIva=(state, getters) => {
  const bases = BASES_LABELS.filter((x)=>x.name.includes('vat'))
  return bases.map((x)=>getters.metadata[x.name]).reduce((x,y)=>zeroIfNull(x)+zeroIfNull(y))
}

const sumBasesIgic=(state, getters) => {
  const bases = BASES_LABELS.filter((x)=>x.name.includes('igic'))
  return bases.map((x)=>getters.metadata[x.name]).reduce((x,y)=>zeroIfNull(x)+zeroIfNull(y))
}

const sumBasesIgi=(state, getters) => {
  const bases = BASES_LABELS.filter((x)=>x.name.includes('igi_'))
  return bases.map((x)=>getters.metadata[x.name]).reduce((x,y)=>zeroIfNull(x)+zeroIfNull(y))
}

const has_meta_iva=(state, getters) => {
  const bases = BASES_LABELS.concat(TAXES_LABELS).filter((x)=>x.name.includes('vat'))
  return bases.map((x)=>getters.metadata[x.name]).reduce((x,y)=>x || y || x===0 || y===0)
}

const has_meta_igic=(state, getters) => {
  const bases = BASES_LABELS.concat(TAXES_LABELS).filter((x)=>x.name.includes('igic_'))
  return bases.map((x)=>getters.metadata[x.name]).reduce((x,y)=>x || y || x===0 || y===0)
}

const has_meta_igic2019=(state, getters) => {
  const bases = BASES_LABELS.concat(TAXES_LABELS).filter((x)=>x.name.includes('igic2019'))
  return bases.map((x)=>getters.metadata[x.name]).reduce((x,y)=>x || y || x===0 || y===0)
}

const has_meta_igi=(state, getters) => {
  const bases = BASES_LABELS.concat(TAXES_LABELS).filter((x)=>x.name.includes('igi_'))
  return bases.map((x)=>getters.metadata[x.name]).reduce((x,y)=>x || y || x===0 || y===0)
}

const sumBases=(state, getters) => {
  const vats = BASES_LABELS.concat(TAXES_LABELS).filter((x)=>x.name.includes('vat'))
  const igics = BASES_LABELS.concat(TAXES_LABELS).filter((x)=>x.name.includes('igic'))
  return vats.concat(igics).map((x)=>getters.metadata[x.name]).reduce((x,y)=>zeroIfNull(x)+zeroIfNull(y))
}

const isWaitingFlow = (state, getters,rootGetters) => {
  return rootGetters.permissions.permission.is_readonly || state.flowLoading || !state.document || ['move_validated','move_created','data_formatted','data_validated','nif_validated'].includes(state.document.state) || ['pending','running'].includes(state.document.async_job_state)
}

const getters = {
  documentFetched: state => !!state.id && !state.docLoading && !state.docError && !!state.document,
  currentDocument: state => state.document,
  currentDocuments: state => state.documents.results,
  currentPage: state => state.currentPage,
  currentPagination: state => state.documents,
  currentIndex: state => state.index,
  currentDocumentState: (_, getters) => getters.currentDocument["state"],
  currentDocumentData,
  documentUrl: state => state.document ? state.document.signed_url : null,
  taggedText: (_, getters) => getters.currentDocument ? getters.currentDocument["textTagging"] : [],
  supplierdb: (_, getters) => getters.currentDocument ? getters.currentDocument["supplierdb"] : [],
  customerdb: (_, getters) => getters.currentDocument ? getters.currentDocument["customerdb"] : [],
  kind: (_, getters) => getters.currentDocument ? getters.currentDocument["kind"] : [],
  selectedText: state => state.selectedText,
  metadata: (_, getters) => getters.currentDocument ? getters.currentDocument["metadata"] : {},
  flowLoading: state => state.flowLoading,
  documentWriting: state => state.docWriteLoading,
  selectedLabel: state => state.selectedLabel,
  selectedTextPayload,
  docState: state => state.docState,
  dirty: state => state.dirty,
  actividad: (_, getters) => getters.currentDocument ? getters.currentDocument["actividad"] : [],
  actividad_str: (_, getters) => getters.currentDocument ? getters.currentDocument["actividad_str"] : [],
  project: (_, getters) => getters.currentDocument ? getters.currentDocument["project"]: [],
  channel: (_, getters) => getters.currentDocument ? getters.currentDocument["channel"]: [],
  expens_income_type: (_, getters) => getters.currentDocument ? getters.currentDocument["expens_income_type"]: [],

  documentsListFilters: state => state.documentsListFilters,
  // isFiltersLoaded: state => state.filters_loaded,
  currentFiltersData: state => state.documentListFiltersData2,
  currentMainFilters: state => state.documentMainFilters,
  currentHeaders,

  currentActions: state => state.documentListAction,

  // documentsListOptions: state => state.documentsListOptions,
  currentLoading: state => state.documentListLoading,
  documentsListState: state => state.documentsListState,
  currentDocumentsItemsLength: state => state.documentsListItemsLength,
  currentDictBool: state => state.documentsListDictBool,
  currentFiltersLoaded: state => state.documentsListFiltersLoaded,
  documentsListId: state => state.documentsListId,
  documentIsTrainerMode: state => state.documentIsTrainerMode,
  loading: state => state.loading,
  loading_info: state => state.loading_info,
  dinamicCallId: state => state.dinamic_call_id,
  checkSumOK: state => state.checkSumOK,
  getMetadataField: state => getField(state.document.metadata),
  getAccountMoveField: state => getField(state.document.accountMoves?state.document.accountMoves[0]:undefined),
  getField,
  sumBases,
  sumBasesIva,
  sumBasesIgic,
  sumBasesIgi,
  has_meta_iva,
  has_meta_igic,
  has_meta_igic2019,
  has_meta_igi,
  isWaitingFlow,
  annotationLayer: state => state.annotationLayer,
  zoom: state => state.zoom,
  rotateJobId: state => state.rotateJobId,
  inRotationMode: state => state.inRotationMode,
  rotationMode: state => state.rotationMode,
  globalRotation: state => state.globalRotation,
  rotationPerDocument: state => state.rotationPerDocument,
  itemsPerPage: state => state.itemsPerPage,
  documentListHeaders: state => state.documentListHeaders,
  supplierdbListHeadersUser: state => state.supplierdbListHeadersUser,
  customerdbListHeadersUser: state => state.customerdbListHeadersUser,

  automatic_payment_account: (state, getters, rootState) => {
    if (
      state.document &&
      state.document.supplierdb_info
    ) {
      if (state.document.supplierdb_info.automatic_payment_account === 'na') {
        return rootState.currentCompany.automatic_payment_account
      } else {
        return state.document.supplierdb_info.automatic_payment_account
      }
    } else {
      return ''
    }
  },

  automatic_charge_account: (state, getters, rootState) => {
    if (
      state.document &&
      state.document.customerdb_info
      ) {
      if (state.document.customerdb_info.automatic_charge_account === 'na') {
        return rootState.currentCompany.automatic_charge_account
      } else {
        return state.document.customerdb_info.automatic_charge_account
      }
    } else {
      return ''
    }

  },

  existsCurrentIndex: (_, getters) => {
    var check = false;
    for(var i = 0; !check && i < getters.currentDocuments.length; i++) {
      check = getters.currentDocuments[i].id == getters.currentDocument.id;
    }
    return check;
  },
  min_footer: state => state.linesAccountMove.min_footer,
  footer_height: state => state.linesAccountMove.footer_height,
  show_invoice_lines: state => state.invoiceLines.show_invoice_lines,
  invoice_lines_height: state => state.invoiceLines.invoice_lines_height,
}

const check_sum = (doc)=>{
  let check=true;
    doc.accountMoves.forEach((account_move) => {
      let credit=0;
      let debit=0;
      account_move.account_move_lines.forEach((line) => {
        credit = credit + parseFloat(line.credit)
        debit = debit + parseFloat(line.debit)
      })
      check = credit!=0 && credit >= debit-0.01 && credit <= debit+0.01
    })
  return check
}

const get_queryset_filters = (state, rootGetters, params) => {
  let currentCompanyId;
  if (rootGetters.getCurrentCompany) {
    currentCompanyId = rootGetters.getCurrentCompany.id;
  } else if (rootGetters["me/userData"].companydb) {
    currentCompanyId = rootGetters["me/userData"].companydb;
  }
  params['filters'] = state.documentsListFilters;
  params['cdb'] = currentCompanyId;
  
  if (state.statesFilter) {
    let states = ''
    for (let i in state.statesFilter) {
      states += state.statesFilter[i] + ','
    }
    params['filters'] = params['filters'] + '&state__in=' + states.slice(0, -1);
  }
  return params;
}

// actions

const getTextTagging =  async ({state,commit}) => {
  let text_tagging = await api_documents.get_text_tagging(state.document.id,0,5000)
  commit(SET_TEXT_TAGGING,{text_tagging:text_tagging,id:state.document.id})
}
const setCurrentPage = (context, num) => {
  context.commit(SET_CURRENT_PAGE, num);
}

const downloadFile = async (context, {signed_url,filename}) => {
  try {
    const response = await fetch(signed_url)
    const blob = await response.blob();
    const url = await URL.createObjectURL(blob)
    const a = document.createElement("a");
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  } catch(err) {
    console.debug(err)
  }
}
const downloadFiles = ({ state, rootGetters }, { send_filters, docs_ids }) => {
  var qs = require('qs');
  return new Promise((resolve, reject) => {
    let values = {};
    if (send_filters) {
      // let currentCompanyId;
      // if (rootGetters.getCurrentCompany) {
      //   currentCompanyId = rootGetters.getCurrentCompany.id;
      // } else if (rootGetters["me/userData"].companydb) {
      //   currentCompanyId = rootGetters["me/userData"].companydb;
      // }
      // values['filters'] = state.documentsListFilters;
      // values['cdb'] = currentCompanyId;
      // if (state.statesFilter) {
      //   let states = ''
      //   for (let i in state.statesFilter) {
      //     states += state.statesFilter[i] + ','
      //   }
      //   values['filters'] = values['filters'] + '&state__in=' + states.slice(0, -1);
      // }
      get_queryset_filters(state, rootGetters, values);
    } else {
      values['documents'] = docs_ids;
    }


    client.get('download_pdfs/', { params: values, paramsSerializer: params => { return qs.stringify(params) }}).then(resp => {
      resolve(resp)
    }).catch(err => {
      reject(err);
    });
  });
}

const downloadFormationDocuments = () => {
    let url = "download_formation_documents/";
    let promise = new Promise((resolve, reject) => {
      client.get(url).then(response => {
        resolve(response);
      }).catch(error => {
        reject(error);
      });
    });
    return promise;
}


const downloadExcel = ({ state, rootGetters }, { send_filters, docs, headers, options }) => {
  return new Promise((resolve, reject) => {
    let aux = [];
    let igics = [
      {text: "Base IGIC 7%", value: "metadata.base_igic_7"},
      {text: "IGIC 7%", value: "metadata.igic_7"},
      {text: "Base IGIC 5%", value: "metadata.base_igic_5"},
      {text: "IGIC 5%", value: "metadata.igic_5"},
      {text: "Base IGIC 3%", value: "metadata.base_igic_3"},
      {text: "IGIC 3%", value: "metadata.igic_3"},
      {text: "Base IGIC 0%", value: "metadata.base_igic_0"},
      {text: "IGIC 0%", value: "metadata.igic_0"},
      {text: "Base IGIC 9,5%", value: "metadata.base_igic_95"},
      {text: "IGIC 9,5%", value: "metadata.igic_95"},
      {text: "Base IGIC 15%", value: "metadata.base_igic_15"},
      {text: "IGIC 15%", value: "metadata.igic_15"},
      {text: "Base IGIC 20%", value: "metadata.base_igic_20"},
      {text: "IGIC 20%", value: "metadata.igic_20"},
    ];
    aux = aux.concat(headers);
    aux.splice.apply(aux, [15, 0].concat(igics));
    aux.splice.apply(aux, [8, 0].concat([{text: "Cuenta Tercero", value: "third_account"},]))
    let params = { 'headers': aux };

    if (send_filters) {
  
      // let currentCompanyId;
      // if (rootGetters.getCurrentCompany) {
      //   currentCompanyId = rootGetters.getCurrentCompany.id;
      // } else if (rootGetters["me/userData"].companydb) {
      //   currentCompanyId = rootGetters["me/userData"].companydb;
      // }
      // params['filters'] = state.documentsListFilters;
      // params['cdb'] = currentCompanyId;
  
      // if (state.statesFilter) {
      //   let states = ''
      //   for (let i in state.statesFilter) {
      //     states += state.statesFilter[i] + ','
      //   }
      //   params['filters'] = params['filters'] + '&state__in=' + states.slice(0, -1);
      // }
      get_queryset_filters(state, rootGetters, params);
  
    } else {
      params['ids'] = [];
      for (let i in docs) {
        params['ids'].push(docs[i].id);
      }
    }
  

    const { sortBy, sortDesc } = options;
    let sortField = false;
    let sortOrder = false;
    if(sortBy){
      sortField = sortBy[0];
    }
    if(sortDesc){
      sortOrder = sortDesc[0];
    }
    params['sortField']=sortField
    params['sortOrder']=sortOrder

    
    client.post('download_docs_excel/', params).then(resp => {
      resolve(resp);
    }).catch(err => {
      reject(err);
    })
  })
}


const checkSum = ({ commit , state}) => {
  let check = check_sum(state.document)
  commit(SET_CHECK_SUM, {check});

}

const fetchDocument = async ({ commit, dispatch,getters, rootGetters, rootState }, { id }) => {
  commit(SET_DOC_ID, { id });
  commit(FETCH_DOC_BEGIN);
  commit(SET_SELECTED_TEXT, { text: null });

  try {
    let response = await api_documents.getDocument({ id })
    if (rootGetters['me/userData']['can_see_training_documents'] || (!rootGetters['me/userData']['available_features']['feature_hide_ocr_boxes']) || rootGetters['me/userData']['available_features']['feature_force_show_ocr_boxes']) {
      let text_tagging = await api_documents.get_text_tagging(id,0,5000)
      response.data.text_tagging = text_tagging
    }
    const { data } = response;
    const document = new Document(data);
    // if(document.accountMoves.length==0)
    //   commit(SET_IS_DISABLED_ACCOUNT_MOVE, { isDisabledAccountMove:true });
    if(document.kind==='payroll'){
      commit(SET_ANNOTATION_LAYER, 'human_payroll')
    }else{
      commit(SET_ANNOTATION_LAYER, 'human');
    }
    commit(FETCH_DOC_SUCCESS, { document });
    //dispatch('pdf_data/setDocumentUrl',getters.documentUrl,{root:true})
    commit(DOCUMENT_TO_PARAM);
    // TODO: Move to a module
    // commit('SET_CURRENT_COMPANY', { id: document.companydb, name: document.companyName, configuration:document.companydb_conf }, { root: true });
    data.companydb_info.name = document.companyName
    // if(!rootState.currentCompany || rootState.currentCompany.id != document.companydb){
    //   //console.log(rootState.currentCompany.id, document.companydb)
    //   if(!rootGetters['me/userData']['can_see_training_documents']){
    //     let new_company=(await dispatch('connector/fetchConnector', {id:document.companydb}, {root:true})).data; //este fetch compite con el fetch de setAfterLogged y gana el más lento. Habría que revisar setAfterlogged
    //     commit('SET_CURRENT_COMPANY', new_company, { root: true }); 
    //   }
    // }
    
    let check = check_sum(document)
    commit(SET_CHECK_SUM, {check});
    return response;
  } catch (error) {
    // TODO: Properly handle call errors
    commit(FETCH_DOC_ERROR);
    commit(RESET_DOC);
    throw error;
  }
};

const documentToParam = ({ state, commit }) => {
  commit(DOCUMENT_TO_PARAM);
};

const fetchDocumentMetadata = async ({ state, commit, rootGetters }, { id }) => {
  commit(SET_DOC_ID, { id });
  //commit(FETCH_DOC_BEGIN);
  commit(SET_SELECTED_TEXT, { text: null });

  try {
    const response = await api_documents.getDocument({ id })
    if ((!rootGetters['me/userData']['available_features']['feature_hide_ocr_boxes']) || rootGetters['me/userData']['available_features']['feature_force_show_ocr_boxes']) {
      let text_tagging = await api_documents.get_text_tagging(id,0,5000)
      response.data.text_tagging = text_tagging
    }
    const { data } = response;
    const document = new Document(data);
    commit(FETCH_METADATA_SUCCESS, {document});
    return response;
  } catch (error) {
    // TODO: Properly handle call errors
    commit(FETCH_DOC_ERROR);
    throw error;
  }
};

const call_continueFlow = async ({ state, getters, commit, dispatch, rootGetters }, cancel_edit, continue_flow_doc) => {
  commit(CONTINUE_FLOW_BEGIN);
  const params = {
    id: state.id,
    id_document:state.document.id,
    metadata: getters.metadata,
    currency: getters.currentDocument.currency,
    supplierdb: getters.supplierdb,
    customerdb: getters.customerdb,
    accountMoves: getters.currentDocument.accountMoves,
    manually_fixed: getters.currentDocument.forced_move,
    kind: getters.kind,
    dirty: getters.dirty,
    punteado: getters.currentDocument.punteado,
    cancel_edit: cancel_edit,
    actividad: getters.actividad,
    project: getters.project,
    channel: getters.channel,
    expens_income_type: getters.expens_income_type,
    inversion_sujeto_pasivo_igic: state.document.inversion_sujeto_pasivo_igic,
    inversion_sujeto_pasivo_iva: state.document.inversion_sujeto_pasivo_iva,
    inversion_sujeto_pasivo_igic_percent: state.document.inversion_sujeto_pasivo_igic_percent,
    inversion_sujeto_pasivo_iva_percent: state.document.inversion_sujeto_pasivo_iva_percent,
    intracomunitario: state.document.intracomunitario,
    intracomunitario_percent: state.document.intracomunitario_percent,
    intracomunitario_type: state.document.intracomunitario_type,
    extracomunitario: state.document.extracomunitario,
    no_sujeta: state.document.no_sujeta,
    bien_inversion: state.document.bien_inversion,
    written_description: state.document.written_description,
    description: state.document.description,
    importaciones_percent: state.document.importaciones_percent,
    comerciante_minorista: state.document.comerciante_minorista,
    gasto_iva_percent: state.document.gasto_iva_percent,
    accounting_date_config: state.document.accounting_date_config,
    default_accounting_date: state.document.default_accounting_date,
    registro_date_config: state.document.registro_date_config,
    default_registro_date: state.document.default_registro_date,
    prorate: state.document.prorate,
    actividad_str: state.document.actividad_str,
    building_code: state.document.building_code,
    apply_modelo: state.document.apply_modelo,
    apply_415: state.document.apply_415,
    serie: state.document.serie,
    doc_number: state.document.doc_number,
    doc_number_prefix: state.document.doc_number_prefix,
    excel_line_index: state.document.excel_line_index,
    retention_type_name: state.document.retention_type_name,
    criterio_de_caja: state.document.criterio_de_caja,
    is_comerciante_minorista: state.document.is_comerciante_minorista,
    inv_number_to_rectify: state.document.inv_number_to_rectify,
    inv_date_to_rectify: state.document.inv_date_to_rectify,
    is_comerciante_minorista_percent: state.document.is_comerciante_minorista_percent,
    written_description_sii: state.document.written_description_sii,
    description_sii: state.document.description_sii,
    continue_flow_doc: continue_flow_doc,
    payment_account: state.document.payment_account,
    charge_account: state.document.charge_account,
    notes: state.document.notes,
    fiscal_location: state.document.fiscal_location,
  }
  if (rootGetters['me/userData'] && rootGetters['me/userData'].can_see_training_documents){
      params['text_tagging']= getters.taggedText;
  }

  if (getters.currentDocument.supplierdb_info) {
    params['supplierdb'] = getters.currentDocument.supplierdb_info['id'];
    //Set Iva check radiobuttons
    params['iva_igic_no_deducible'] = state.selectedIvaCheck == 'iva_igic_no_deducible';
    params['prorate'] = state.selectedIvaCheck == 'prorate';
    params['gasto_iva_parcial'] = state.selectedIvaCheck == 'gasto_iva_parcial';
    if (!params['gasto_iva_percent']) {
      params['gasto_iva_percent'] = 50;
    }
    params['iva_parcial'] = state.selectedIvaCheck == 'iva_parcial';
    if (!params['gasto_iva_percent']) {
      params['gasto_iva_percent'] = 50;
    }
  }
  if (getters.currentDocument.customerdb_info) {
    params['customerdb'] = getters.currentDocument.customerdb_info['id'];
    // Si es de tipo cliente, no hay que tener en cuenta estos campos: ni IVA/IGIC no deducible ni parcialmente deducible.
    params['iva_igic_no_deducible'] = false;
    params['gasto_iva_parcial'] = false;
  }
  try {
    await api_documents.continueFlow({ ...params });
    await dispatch("documents/fetchDocument", { id: state.id }, { root: true });
    commit(CONTINUE_FLOW_SUCCESS);
    let check = check_sum(state.document)
    commit(SET_CHECK_SUM, {check});
  } catch (error) {
    // TODO: Properly handle call errors
    commit(CONTINUE_FLOW_ERROR);
    throw error;
  }
}


const cancelEditFlow = async ({ commit, dispatch, state, getters, rootGetters }) => {
  await call_continueFlow({ commit, dispatch, state, getters, rootGetters }, true, true)
}


const continueFlow = async ({ commit, dispatch, state, getters, rootGetters }) => {
  await call_continueFlow({ commit, dispatch, state, getters, rootGetters }, false, true)
};

const saveDocWithoutContinueFlow = async ({ commit, dispatch, state, getters, rootGetters }) => {
  await call_continueFlow({ commit, dispatch, state, getters, rootGetters }, false, false)
};

const updateAutomaticMoveAccounts = ({ state, rootState, rootGetters, commit }) => {
  if (rootGetters.got_feature('feature_automatic_moves_in_document')) {
    let account = ''

    if (state.document.kind === 'in_invoice') {
      switch (state.document.supplierdb_info.automatic_payment_account) {
        case 'y':
          account = state.document.supplierdb_info.payment_account
          break
        case 'na':
          account = rootState.currentCompany.payment_account
          break
        case 'n':
        case 'm':
        default:
          break
      }

      commit(SET_PAYMENT_ACCOUNT, account)
    }
    else if (state.document.kind === 'out_invoice') {
      switch (state.document.customerdb_info.automatic_charge_account) {
        case 'y':
          account = state.document.customerdb_info.charge_account
          break
        case 'na':
          account = rootState.currentCompany.charge_account
          break
        case 'n':
        case 'm':
        default:
          break
      }
      commit(SET_CHARGE_ACCOUNT, account)
    }
  }
}

const deleteLabel = ({ rootGetters, getters, state }, { label }) => {
  // TODO: Is this router check needed?
  if (rootGetters.router.currentRoute.name == 'document-detail') {
    getters.taggedText.forEach(page => {
      page.forEach(x => {
      if (x.label[rootGetters["documents/annotationLayer"]] === label) {
        // FIXME: Do not modify state here
        // Launch a message ex. commit(...) CHANGE_LABEL or DELETE_LABEL
        x.label[rootGetters["documents/annotationLayer"]] = 'background'
      }
      })
    })
  }
};

const setDirty = ({ commit }) => {
  commit(SET_DIRTY);

}
const saveLabels = async ({ state, getters, commit, rootGetters, rootState }, { and_go_back_to = false } = {}) => {
  // TODO: Is this router check needed?
  if (rootGetters.router.currentRoute.name == 'document-detail') {
    commit(WRITE_DOC_BEGIN);
    const params = {
      id: state.id,
      state: getters.currentDocument.state,
      company: rootState.currentCompany.id,
      punteado: getters.currentDocument.punteado,
      supplierdb: getters.currentDocument.supplierdb,
      customerdb: getters.currentDocument.customerdb,
      comment: getters.currentDocument.comment,
      tags: getters.currentDocument.tags,
      kind: getters.currentDocument.kind,
      metadata: getters.currentDocument.metadata,
      forced_move: getters.currentDocument.forced_move,
      actividad: getters.currentDocument.actividad,
      project: getters.currentDocument.project,
      channel: getters.currentDocument.channel,
      expens_income_type: getters.currentDocument.expens_income_type,
      inversion_sujeto_pasivo_igic: getters.currentDocument.inversion_sujeto_pasivo_igic,
      inversion_sujeto_pasivo_iva: getters.currentDocument.inversion_sujeto_pasivo_iva,
      inversion_sujeto_pasivo_igic_percent: getters.currentDocument.inversion_sujeto_pasivo_igic_percent,
      inversion_sujeto_pasivo_iva_percent: getters.currentDocument.inversion_sujeto_pasivo_iva_percent,
      intracomunitario: getters.currentDocument.intracomunitario,
      intracomunitario_percent: getters.currentDocument.intracomunitario_percent,
      intracomunitario_type: getters.currentDocument.intracomunitario_type,
      extracomunitario: getters.currentDocument.extracomunitario,
      no_sujeta: getters.currentDocument.no_sujeta,
      bien_inversion: getters.currentDocument.bien_inversion,
      written_description: getters.currentDocument.written_description,
      description: getters.currentDocument.description,
      importaciones_percent: getters.currentDocument.importaciones_percent,
      comerciante_minorista: getters.currentDocument.comerciante_minorista,
      gasto_iva_percent: getters.currentDocument.gasto_iva_percent,
      accounting_date_config: getters.currentDocument.accounting_date_config,
      default_accounting_date: getters.currentDocument.default_accounting_date,
      prorate: getters.currentDocument.prorate,
      actividad_str: getters.currentDocument.actividad_str,
      building_code: getters.currentDocument.building_code,
      apply_modelo: getters.currentDocument.apply_modelo,
      apply_415: getters.currentDocument.apply_415,
      serie: getters.currentDocument.serie,
      doc_number: getters.currentDocument.doc_number,
      doc_number_prefix: getters.currentDocument.doc_number_prefix,
      excel_line_index: getters.currentDocument.excel_line_index,
      currency: getters.currentDocument.currency,
      retention_type_name: getters.currentDocument.retention_type_name,
      is_comerciante_minorista: getters.currentDocument.is_comerciante_minorista,
      is_comerciante_minorista_percent: getters.currentDocument.is_comerciante_minorista_percent,
      fiscal_location: getters.currentDocument.fiscal_location,
    }
    let keys = Object.keys(params['metadata'])
    for(let i in keys){
      let k = keys[i]
      if(k.includes('vat_') && params['metadata'][k]==''){
        delete params['metadata'][k];
      }
    }
    if (rootGetters['me/userData'].can_see_training_documents){
      params['text_tagging']= getters.taggedText;
    }
    if (getters.currentDocument.supplierdb_info) {
      params['supplierdb'] = getters.currentDocument.supplierdb_info['id'];
      //Set Iva check radiobuttons
      params['iva_igic_no_deducible'] = state.selectedIvaCheck == 'iva_igic_no_deducible';
      params['gasto_iva_parcial'] = state.selectedIvaCheck == 'gasto_iva_parcial';
      if (!params['gasto_iva_percent']) {
        params['gasto_iva_percent'] = 50;
      }
      params['iva_parcial'] = state.selectedIvaCheck == 'iva_parcial';
      if (!params['gasto_iva_percent']) {
        params['gasto_iva_percent'] = 50;
      }
    }
    if (getters.currentDocument.customerdb_info) {
      params['customerdb'] = getters.currentDocument.customerdb_info['id'];
    }
    try {
      const response = await api_documents.patchDocument({ ...params });
      const { data } = response;
      const document = new Document(data);
      commit(WRITE_DOC_SUCCESS, { document });
      // TODO: Move to a module
      data.companydb_info.name = document.companyName
      commit('SET_CURRENT_COMPANY', data.companydb_info, { root: true });
      if (and_go_back_to) {
        rootGetters.router.push(and_go_back_to);
      }
      return response;
    } catch (error) {
      commit(WRITE_DOC_ERROR);
      throw error;
    }
  }
};

const saveAccountMoves = async ({ commit, getters }) => {
  let accountMoves = getters.currentDocument.accountMoves;
  commit(WRITE_DOC_BEGIN);
  const response = await api_documents.updateAccountMoves({ accountMoves });
  const { data } = response;
  commit(SET_ACCOUNT_MOVES, data);

};

const selectLabel = ({ commit, getters }, { label }) => {
  commit(SET_SELECTED_LABEL, { label });
};

const setSelectedText = ({ commit, getters, rootGetters }, { index }) => {
  commit(SET_SELECTED_TEXT, { index });
  if (getters.currentDocument) {
    if (index!==null && getters.selectedLabel) {
      const annotationLayer = rootGetters["documents/annotationLayer"];
      commit(SET_DOC_LABEL, {
        label: getters.selectedLabel,
        index,
        annotationLayer
      });
    }
  }
};


const nextLabel = ({ dispatch, rootGetters }) => {
  // TODO: Is this router check needed?
  if (rootGetters.router.currentRoute.name == 'document-detail') {
    dispatch("incLabel", { delta: 1 });
  }
};

const previousLabel = ({ dispatch, rootGetters }) => {
  // TODO: Is this router check needed?
  if (rootGetters.router.currentRoute.name == 'document-detail') {
    dispatch("incLabel", { delta: -1 })
  }
};

const incLabel = ({ dispatch, getters, rootGetters, rootState }, { delta }) => {
  let label = undefined;
  if (getters.selectedLabel) {
    const newIndex = (
      rootGetters["getLabels"].findIndex(x => x.name === getters.selectedLabel) + delta + rootGetters["getLabels"].length
    ) % rootGetters["getLabels"].length

    label = rootGetters["getLabels"][newIndex].name
  } else {
    label = rootGetters["getLabels"][0].name
  }
  dispatch("selectLabel", { label });
}

const end = ({ commit }) => {
  commit(SET_DOC_STATE, { state: 'human_annotated' });
};

const setCurrentDocs = ({ commit }, docs) => {
  commit(SET_CURRENT_DOCUMENTS, { docs });
};

const updateCurrentIndex = ({ dispatch, getters, rootGetters, rootState, commit }) => {
  var index = 0;
  for(var i = 0; i < getters.currentDocuments.length; i++) {
    if (getters.currentDocuments[i].id == getters.currentDocument.id) {
      index = i;
      break;
    }
  }
  commit(SET_CURRENT_INDEX, {index});
};

const setCurrentIndex = ({ commit }, index) => {
  commit(SET_CURRENT_INDEX, { index });
};

const resetDocument = ({ commit }) => {
  commit(RESET_DOC);
};

const setCurrentFilters = ({ commit }, documentsListFilters) => {
  commit(SET_CURRENT_FILTERS, { documentsListFilters });
};

const setCurrentLoading = ({ commit }, loading) => {
  commit(SET_CURRENT_LOADING, { loading });
};

const setCurrentOptions = ({ commit }, options) => {
  commit(SET_CURRENT_OPTIONS, { options });
};

const setItemsLength = ({ commit }, itemsLength) => {
  commit(SET_ITEMS_LENGTH, { itemsLength });
};

const setDictBoolStates = ({ commit }, dictBoolStates) => {
  commit(SET_DICT_BOOL_STATES, { dictBoolStates });
};

const setDictBoolTags = ({ commit }, dictBoolTags) => {
  commit(SET_DICT_BOOL_TAGS, { dictBoolTags });
};

const setFiltersLoaded = ({ commit }, filtersLoaded) => {
  commit(SET_FILTERS_LOADED, { filtersLoaded });
};

const setFiltersDataStatesValues = ({ commit }, filtersDataStatesValues) => {
  commit(SET_FILTERS_DATA_STATES_VALUES, { filtersDataStatesValues });
};

const setFiltersDataTagsValues = ({ commit }, filtersDataTagsValues) => {
  commit(SET_FILTERS_DATA_TAGS_VALUES, { filtersDataTagsValues });
};

const setFiltersDataActividadStrValues = ({ commit }, filtersDataActividadStrValues) => {
  commit(SET_FILTERS_DATA_ACTIVIDAD_STR_VALUES, { filtersDataActividadStrValues });
};

const setFiltersDataActividadValues = ({ commit }, filtersDataActividadValues) => {
  commit(SET_FILTERS_DATA_ACTIVIDAD_VALUES, { filtersDataActividadValues });
};

const setFilterDataEjercicioValue = ({ commit }, filtersDataEjercicioValue) => {
  commit(SET_FILTERS_DATA_EJERCICIO_VALUE, { filtersDataEjercicioValue });
};

const setFilterDataProjectValue = ({ commit }, filtersDataProjectValue) => {
  commit(SET_FILTERS_DATA_PROJECT_VALUE, { filtersDataProjectValue });
};

const setFilterDataEjercicioUserValues = ({ commit }, filtersDataEjercicioUserValues) => {
  commit(SET_FILTERS_DATA_EJERCICIO_USER_VALUES, { filtersDataEjercicioUserValues });
};

const setFiltersDataIdValue = ({ commit }, filtersDataIdValue) => {
  commit(SET_FILTERS_DATA_ID_VALUE, { filtersDataIdValue });
};

const setFiltersDataStateValue = ({ commit }, filtersDataStateValue) => {
  commit(SET_FILTERS_DATA_STATE_VALUE, { filtersDataStateValue });
};

const setFiltersDataSearchValue = ({ commit }, filtersDataSearchValue) => {
  commit(SET_FILTERS_DATA_SEARCH_VALUE, { filtersDataSearchValue });
};
const setFiltersDataSearchDuplicateValue = ({ commit }, filtersDataSearchDuplicateValue) => {
  commit(SET_FILTERS_DATA_SEARCH_DUPLICATE_VALUE, { filtersDataSearchDuplicateValue });
};

const setDocumentKind = ({ commit }, kind) => {
  commit(SET_DOCUMENT_KIND, kind);
}

const setFiltersDataTagsValue = ({ commit }, filtersDataTagsValue) => {
  commit(SET_FILTERS_DATA_TAGS_VALUE, { filtersDataTagsValue });
};

const setFiltersDataEntryNumberValue = ({ commit }, filtersDataEntryNumberValue) => {
  commit(SET_FILTERS_DATA_ENTRY_NUMBER_VALUE, { filtersDataEntryNumberValue });
};

const setFiltersDataAccountMoveNumberValue = ({ commit }, filtersDataAccountMoveNumberValue) => {
  commit(SET_FILTERS_DATA_ACCOUNT_MOVE_NUMBER_VALUE, { filtersDataAccountMoveNumberValue });
};

const downloadMergedDocuments = ({ state, rootGetters }, { send_filters, docs, options }) => {
  const { sortBy, sortDesc } = options;
  let sortField = false;
  let sortOrder = false;
  if(sortBy){
    sortField = sortBy[0];
  }
  if(sortDesc){
    sortOrder = sortDesc[0];
  }
  let params = {}
  if (send_filters) {

    // let currentCompanyId;
    // if (rootGetters.getCurrentCompany) {
    //   currentCompanyId = rootGetters.getCurrentCompany.id;
    // } else if (rootGetters["me/userData"].companydb) {
    //   currentCompanyId = rootGetters["me/userData"].companydb;
    // }
    // params['filters'] = state.documentsListFilters;
    // params['cdb'] = currentCompanyId;

    // if (state.statesFilter) {
    //   let states = ''
    //   for (let i in state.statesFilter) {
    //     states += state.statesFilter[i] + ','
    //   }
    //   params['filters'] = params['filters'] + '&state__in=' + states.slice(0, -1);
    // }

    get_queryset_filters(state, rootGetters, params);

  } else {
    params['ids'] = [];
    for (let i in docs) {
      params['ids'].push(docs[i].id);
    }
  }
  params['sortField']=sortField;
  params['sortOrder']=sortOrder;
  return client.post('download_merged_documents/', params);
}

const getRetryDetectionStates = async() => {
  let response = await api_documents.getRetryDetectionStates()
  return response.data.result;
  // return [
  //       "required_review",
  //       "error_third_accounts",
  //       "third_accounts_validated",
  //       "accounts_assigned",
  //       "assigned_contract",
  //       "error_validating_moves",
  //       "human_annotated",
  //       "move_validated",
  //       "error_supplier_not_found",
  //       "data_detected",
  //       "error_creating_moves",
  //       "in_rotation",
  //       "not_supported",
  //       "nif_validated",
  //       "data_formatted",
  //       "error_format",
  //       "error_text_detection",
  //       "error_assigning_accounts",
  //       "move_created",
  //       "nif_detected",
  //       "pending",
  //       "preprocessed",
  //       "uploading_bucket",
  //       "merging",
  //       "preprocessing",
  //       "error",
  //       "check_duplicated_ok",
  //       "split",
  //       "data_validated",
  //       "error_customer_not_found",
  //       "error_validating_data",
  //       "move_loaded",
  //       "error_account_connector",
  //       "text_detected",
  //       "oriented",
  //       "pending_upload",
  //       "accounting_invoice",
  //       "accounting_payment_move",
  //       "error_checking_taxes",
  //       "error_already_destination",
  //       "backtracking",
  //       "error_critical"
  //   ]
}

const dinamic_get_list_documents = async ({ commit, state, getters, rootGetters, dispatch}, {qs,currentCompanyId,currentCallId}) => {
  let canSeeTrainingDocuments = rootGetters["me/userData"].can_see_training_documents;
  let cut=50;
  
  let res;
  if (qs && qs.currentCompanyId) {
    let companyKey = qs.currentCompanyId.toString();
    dispatch('setting_repository/setSettings', {settings: companyKey, value: qs}, { root: true });
  }
  if(qs.itemsPerPage<cut+1){
    commit(SET_LOADING_INFO, { info:'' });
    try {
      res = await api_documents.listDocuments(qs);
    } catch(error) {
      if (qs.currentCompanyId) {
        let companyKey = qs.currentCompanyId.toString();
        dispatch('setting_repository/removeSettings', {settings: companyKey}, { root: true });
      }
      throw error;
    }
    let currentCompanyId2 = get_currentCompanyId({rootGetters});
    if(currentCompanyId==currentCompanyId2 || canSeeTrainingDocuments){
      let docs = res.data
      commit(SET_CURRENT_DOCUMENTS, { docs });
      let count = res.data.count
      commit(SET_ITEMS_LENGTH,  { itemsLength:count });
    }
    return res
  } 
  else{
    let page = qs.page - 1
    let i = 0
    let currentCompanyId2 = get_currentCompanyId({rootGetters});
    let results = []
    let docs = undefined
    let count = 1
    let offset = 0
    commit(SET_LOADING_INFO, { info:'' });
    while(i < qs.itemsPerPage/cut && offset < count && ((currentCompanyId==currentCompanyId2 && currentCallId==getters.dinamicCallId) || canSeeTrainingDocuments)){
      let split_qs = {...qs, itemsPerPage: cut, page:page*(qs.itemsPerPage/cut)+i+1};
      try {
        res = await api_documents.listDocuments(split_qs);
      } catch (error) {
        if (qs.currentCompanyId) {
          let companyKey = qs.currentCompanyId.toString();
          dispatch('setting_repository/removeSettings', {settings: companyKey}, { root: true });
        }
        throw error;
      }
      docs = res.data
      results = results.concat(res.data.results) 
      docs.results = results
      if((currentCompanyId==currentCompanyId2 && currentCallId==getters.dinamicCallId) || canSeeTrainingDocuments){
        commit(SET_CURRENT_DOCUMENTS, { docs });
        offset = (page*(qs.itemsPerPage/cut)+i+1)*cut
        count = res.data.count
        commit(SET_ITEMS_LENGTH, { itemsLength:count });
        let loading_info = Math.min(offset-page*qs.itemsPerPage,count).toString() + '/' + Math.min(count-(qs.itemsPerPage)*page,qs.itemsPerPage).toString()
        commit(SET_LOADING_INFO, { info:loading_info });
        currentCompanyId2 = get_currentCompanyId({rootGetters});
      }
      i+=1
    }
    return docs
  } 
}

const refreshData = async ({ commit, state, getters, rootGetters, dispatch }) => {
  let currentCompanyId = get_currentCompanyId({rootGetters});
  let currentCallId = Date.now().toString()
  commit(SET_DINAMIC_CALL_ID, {id:currentCallId})
  if(currentCompanyId) {
    commit(SET_CURRENT_LOADING, true);
    commit(UNSELECT_DOCUMENTS);

    const { page, itemsPerPage, sortBy, sortDesc } = state.documentListOptions;
    const filters = getters.documentsListFilters;
    const statesFilter = state.statesFilter;
    const documentsListId = getters.documentsListId;
    let sortField = undefined;
    let sortOrder = undefined;
    if(sortBy){
      sortField = sortBy[0];
    }
    if(sortDesc){
      sortOrder = sortDesc[0];
    }
    commit(SET_CURRENT_LOADING, { loading: true });
    await dispatch("me/refreshUserData",'',{root:true})
    let canSeeTrainingDocuments = rootGetters["me/userData"].can_see_training_documents;
    currentCompanyId = canSeeTrainingDocuments?undefined:currentCompanyId;
    let kind = state.dpcumentListKind
    let qs = {page, itemsPerPage, filters, currentCompanyId, statesFilter, documentsListId, kind, sortField, sortOrder}
    let response = await dispatch('dinamic_get_list_documents',{qs,currentCompanyId, currentCallId})
    let currentCompanyId2 = get_currentCompanyId({rootGetters});
    currentCompanyId2 = canSeeTrainingDocuments?undefined:currentCompanyId2;
    if (getters.currentDocument) {
      dispatch('updateCurrentIndex', { commit, state, getters, rootGetters, dispatch });
    }
    if(currentCompanyId==currentCompanyId2 && currentCallId==getters.dinamicCallId){
      commit(SET_CURRENT_LOADING, { loading: false });
      for (let i in getters.currentFiltersData) {
        if (i == 'state') {
          if(currentCompanyId || canSeeTrainingDocuments){
            let filts = '';
            if (filters) {
              filts = filters;
            }
            api_documents.getDocumentStates({ currentCompanyId, filts }).then(response => {
              if(currentCompanyId==currentCompanyId2 && currentCallId==getters.dinamicCallId){
                let filtersDataStatesValues = response.data['all_states'];
                commit(SET_FILTERS_DATA_STATES_VALUES, { filtersDataStatesValues });
                let mainfilters = response.data['main_states'];
                commit(SET_MAIN_FILTERS, { mainfilters });
                let dictBoolStates = true;
                commit(SET_DICT_BOOL_STATES, { dictBoolStates });
                if (getters.currentDictBool['states'] && getters.currentDictBool['tags']) {
                  let filtersLoaded = true;
                  commit(SET_FILTERS_LOADED, { filtersLoaded });
                }
              }
            }, error => {
              dispatch('setting_repository/removeSettings', {settings: currentCompanyId}, { root: true });
            });
          }
        }
        if (i == 'tags') {
          if(currentCompanyId || canSeeTrainingDocuments){
            client.get("tags/?limit=100").then(response => {
              let filtersDataTagsValues = response.data.results;
              commit(SET_FILTERS_DATA_TAGS_VALUES, { filtersDataTagsValues });
              let dictBoolTags = true
              commit(SET_DICT_BOOL_TAGS, { dictBoolTags });
              if (getters.currentDictBool['states'] && getters.currentDictBool['tags']) {
                let filtersLoaded = true;
                commit(SET_FILTERS_LOADED, { filtersLoaded });
              }
            });
          }
        }
      }
      return response
    }
  }
  return false;
};

const setIsTrainerMode = ({ commit }, isTrainerMode) => {
  commit(SET_IS_TRAINER_MODE, { isTrainerMode });
};

const setIsDebuggerMode = ({ commit }, isDebuggerMode) => {
  commit(SET_IS_DEBUGGER_MODE, { isDebuggerMode });
};

const setForcedMove = ({ commit }, forced_move) => {
  commit(SET_FORCED_MOVE, forced_move);
};

const multiContinueFlow= async ({ state, rootGetters }, { send_filters, docs }) => {
    let params = {};
    if (send_filters) {
      params = get_queryset_filters(state, rootGetters, params);
    } else {
      let ids=[];
      docs.forEach((e)=>{
        ids.push(e.id);
      })
      params['doc_ids'] = ids;
    }
    return await api_documents.multiContinueFlow(params);
};

const multiRetryAll= async ({}, docs) => {
  let ids=[]
  docs.forEach((e)=>{
    ids.push(e.id)
  })
  return await api_documents.multiRetryAll(ids)
};

const markDocAsErrorAccountConnector = ({ state, rootGetters }, { send_filters, docs }) => {
  return new Promise((resolve, reject) => {
    let params = {};
    if (send_filters) {
      params = get_queryset_filters(state, rootGetters, params);
    } else {
      params['doc_ids'] = docs;
    }
    client.post('mark_doc_as_error_account_connector/', params).then(resp => {
      resolve(resp);
    }).catch(err => {
      reject(err);
    });
  }); 
};

const markAsPunteado = ({ state, rootGetters }, { send_filters, docs }) => {
  return new Promise((resolve, reject) => {
    let params = {};
    if (send_filters) {
      params = get_queryset_filters(state, rootGetters, params);
    } else {
      params['doc_ids'] = docs;
    }
    client.patch('mark_doc_as_punteado/', params).then(resp => {
      resolve(resp);
    }).catch(err => {
      reject(err);
    });
  }); 
};

const markAsDespunteado = ({ state, rootGetters }, { send_filters, docs }) => {
  return new Promise((resolve, reject) => {
    let params = {};
    if (send_filters) {
      params = get_queryset_filters(state, rootGetters, params);
    } else {
      params['doc_ids'] = docs;
    }
    
    client.patch('mark_doc_as_despunteado/', params).then(resp => {
      resolve(resp);
    }).catch(err => {
      reject(err);
    });
  }); 
};

const setNeedsTtFixState = ({ state }, {value, docs }) => {
  return new Promise((resolve, reject) => {
    client.patch('set_needs_tt_fix/', {value, docs }).then(resp => {
      resolve(resp);
    }).catch(err => {
      reject(err);
    });
  }); 
};
const setAnnotationLayer = ({ commit }, str) => {
  commit(SET_ANNOTATION_LAYER, str);
}

const setZoom = ({ commit }, zoom) => {
  commit(SET_ZOOM, zoom);
}

const setRotation = ({ commit }, bool) => {
  commit(SET_ROTATION, bool);
}

const setRotationMode = ({ commit }, mode) => {
  commit(SET_ROTATION_MODE, mode);
}

const doRotate = ({ state, commit }, {page, rotation}) => {
  if (state.rotationMode === 'all') {
    commit(SET_GLOBAL_ROTATION, rotation);
  } else {
    commit(SET_DOCUMENT_ROTATION, {page, rotation});
  }
}

const cancelRotationMode = ({ commit }) => {
  commit(CANCEL_ROTATION)
}

const saveRotation = async ({ commit, state }) => {
  const rotationPerDocumentZfill = []
  for (let i = 0; i < state.rotationPerDocument.length - 1; i++) {
    rotationPerDocumentZfill[i] = state.rotationPerDocument[i+1] || 0
  }
  try {
    const response = await api_documents.saveRotation({
      id: state.id,
      globalRotation: state.globalRotation,
      rotationPerDocument: rotationPerDocumentZfill
    })
    commit(SET_ROTATION_TASK, response.data.job_id)
  } catch (error) {
    console.log('saveRotationError:')
    console.error(error)
  }
}

const massiveRotation = ({}, {ids, rotation}) => {
  let params = {
    'ids': ids,
    'rotation': rotation,
  };
  return new Promise((resolve, reject) => {
    client.post('massive_rotation/', params).then(resp => {
      resolve(resp);
    }).catch(err => {
      reject(err);
    });
  });
}

const massiveCalculateBaseCuota = ({ state, rootGetters }, {send_filters, ids, percent}) => {
  let params = {
    // 'ids': ids,
    'percent': percent
  }
  if (send_filters) {
    params = get_queryset_filters(state, rootGetters, params);
  } else {
    params['ids'] = ids;
  }
  return new Promise((resolve, reject) => {
    client.post('recalculate_base_cuota/', params).then(resp => {
      resolve(resp);
    }).catch(err => {
      reject(err);
    });
  });
}

const massiveFixRound = ({ state, rootGetters }, {send_filters, docs}) => {
  let params = { 'currentCompany': rootGetters.getCurrentCompany.id };
  if (send_filters) {
    params = get_queryset_filters(state, rootGetters, params);
  } else {
    params['ids'] = docs;
  }
  return new Promise((resolve, reject) => {
    client.post('massive_fix_round_action/', params).then(resp => {
      resolve(resp);
    }).catch(err => {
      reject(err);
    });
  });
}

const massiveFixMismatchEx0 = ({ state, rootGetters }, {send_filters, docs}) => {
  let params = { 'currentCompany': rootGetters.getCurrentCompany.id };
  if (send_filters) {
    params = get_queryset_filters(state, rootGetters, params);
  } else {
    params['ids'] = docs;
  }
  return new Promise((resolve, reject) => {
    client.post('massive_fix_mismatch_ex0_action/', params).then(resp => {
      resolve(resp);
    }).catch(err => {
      reject(err);
    });
  });
}

const massiveForceSendDocuments = ({ state, rootGetters }, {send_filters, docs}) => {
  let params = { 'currentCompany': rootGetters.getCurrentCompany.id };
  if (send_filters) {
    params = get_queryset_filters(state, rootGetters, params);
  } else {
    params['ids'] = docs;
  }
  return new Promise((resolve, reject) => {
    client.post('massive_force_send_documents_action/', params).then(resp => {
      resolve(resp);
    }).catch(err => {
      reject(err);
    });
  });
}

const setIntraDataFromThirdParty = ({ commit, rootGetters }, thirddb_info) => {
  if (thirddb_info) {
    let currentCompany = rootGetters.getCurrentCompany;
    let set_flag_bien_inversion = currentCompany && currentCompany.companydb_type && ((currentCompany.companydb_type.type == 'account_move') || (currentCompany.companydb_type.type == 'invoice' && 'desglose_de_cuentas' in currentCompany.companydb_type.params && currentCompany.companydb_type.params['desglose_de_cuentas']));
    let set_account_metadata = false;
    if(rootGetters['me/userData']['available_features']['feature_expens_account_metadata'] && currentCompany && currentCompany.companydb_type.params && currentCompany.companydb_type.params['show'] && currentCompany.companydb_type.params['show'].includes('expens_account_metadata')){
      set_account_metadata = true;
    }
    let actividad_kind = '';
    if (currentCompany && currentCompany.companydb_type.params && currentCompany.companydb_type.params['show'] && currentCompany.companydb_type.params['show'].includes('actividad')) {
      actividad_kind = 'actividad';
    }
    else if(currentCompany && currentCompany.companydb_type.params && currentCompany.companydb_type.params['show'] && currentCompany.companydb_type.params['show'].includes('actividad_str')) {
      actividad_kind = 'actividad_str';
    }
    let feature_default_project_channel_in_third = rootGetters['me/userData']['available_features']['feature_default_project_channel_in_third']
    let feature_extra_supplier = rootGetters.got_feature('feature_extra_supplier')
    commit(SET_INTRA_DATA_FROM_SUPPLIER, {thirddb_info, set_flag_bien_inversion, set_account_metadata, feature_default_project_channel_in_third, actividad_kind, feature_extra_supplier});
  }
}

const setCriteriodeCaja = ({commit}, supplierdb_info) => {
  if (supplierdb_info) {
    commit(SET_CRITERIO_DE_CAJA, supplierdb_info.criterio_de_caja);
  }
}

const setIsComercianteMinorista = ({ commit }, supplierdb_info) => {
  if (supplierdb_info) {
    commit(SET_IS_COMERCIANTE_MINORISTA, supplierdb_info.is_comerciante_minorista)
  }
}

const setInvNumberToRectify = ({ commit }, inv_number_to_rectify) => {
  commit(SET_INV_NUMBER_TO_RECTIFY, inv_number_to_rectify);
}

const setInvDateToRectify = ({ commit }, inv_date_to_rectify) => {
  commit(SET_INV_DATE_TO_RECTIFY, inv_date_to_rectify);
}

const setIntraDataFromCustom = ({ commit }, {param, value, value2}) => {
  commit(SET_INTRA_DATA_FROM_CUSTOM, {param, value, value2});
}

const setType0 = ({commit,rootGetters,state}, third_info) => {
  if (third_info && rootGetters.got_feature('feature_exenta_no_sujeta')){
    let tax_type = rootGetters.getCurrentCompany.tax_type
    setType0metadata(tax_type, third_info, state.document.metadata, commit, SET_IVA_0_FROM_TO);
    
  }
  
}

const setItemsPerPage = ({ commit }, itemsPerPage) => {
  commit(SET_ITEMS_PER_PAGE, itemsPerPage);
}

const setCurrentDocumentSupplierDB = ({ commit }, { currentDocumentSupplierdb, currentDocumentSupplierdbInfo, isBienInversionChanged, areIvaChecksChanged }) => {
  commit(SET_CURRENT_DOCUMENT_SUPPLIERDB, { currentDocumentSupplierdb, currentDocumentSupplierdbInfo, isBienInversionChanged, areIvaChecksChanged });
}

const setCurrentDocumentCustomerDB = ({ commit }, { currentDocumentCustomerdb, currentDocumentCustomerdbInfo }) => {
  commit(SET_CURRENT_DOCUMENT_CUSTOMERDB, { currentDocumentCustomerdb, currentDocumentCustomerdbInfo });
}
const setCurrentHeaders = ({ commit, state, getters, rootGetters, dispatch }) => {
  let index1 = state.documentListHeaders.findIndex(function(item, i){
    return item.value === 'entry_number';
  });
  if (index1 > 0) {
    commit(REMOVE_DOCUMENTS_LIST_HEADERS_ELEM_BY_INDEX, index1);
  }
  let index2 = state.documentListHeaders.findIndex(function(item, i){
    return item.value === 'account_move_number';
  });
  if (index2 > 0) {
    commit(REMOVE_DOCUMENTS_LIST_HEADERS_ELEM_BY_INDEX, index2);
  }


  let index3 = state.documentListHeaders.findIndex(function(item, i){
    return item.value === 'username';
  });
  if (index3 > 0) {
    commit(REMOVE_DOCUMENTS_LIST_HEADERS_ELEM_BY_INDEX, index3);
  }

  let index4 = state.documentListHeaders.findIndex(function(item, i) {
    return item.value === 'created';
  });
  if (index4 > 0) {
    commit(REMOVE_DOCUMENTS_LIST_HEADERS_ELEM_BY_INDEX, index4);
  }

  let index5 = state.documentListHeaders.findIndex(function(item, i) {
    return item.value === 'punteado';
  });
  if (index5 > 0) {
    commit(REMOVE_DOCUMENTS_LIST_HEADERS_ELEM_BY_INDEX, index5);
  }

  let elem = {};

  if (rootGetters['me/userData']['companydb']) {
    if (rootGetters['me/userData']['companydb']['companydb_type'] && rootGetters['me/userData']['companydb']['companydb_type']['type'] == 'invoice') { 
      elem = {text: "Apunte", value: "entry_number", width: 100};
      commit(SET_DOCUMENTS_LIST_HEADERS_ELEM, elem);
    } else {
      elem = {text: "Asiento", value: "account_move_number", width: 100};
      commit(SET_DOCUMENTS_LIST_HEADERS_ELEM, elem);
    }
  } else {
    if (rootGetters.getCurrentCompany && rootGetters.getCurrentCompany.companydb_type && rootGetters.getCurrentCompany.companydb_type.type == 'invoice') {
      elem = {text: "Apunte", value: "entry_number", width: 100};
      commit(SET_DOCUMENTS_LIST_HEADERS_ELEM, elem);
    } else {
      elem = {text: "Asiento", value: "account_move_number", width: 100};
      commit(SET_DOCUMENTS_LIST_HEADERS_ELEM, elem);
    }
  }
  dispatch('me/refreshUserData', {}, {root:true}).then(() => {
    if (rootGetters['me/userData']['available_features']['feature_can_see_doc_created_date']) {
      elem = {text: "Fecha de subida", value: "created", width: 150};
      commit(SET_DOCUMENTS_LIST_HEADERS_ELEM, elem);
    }

    if (rootGetters['me/userData']['can_see_training_documents']) {
      elem = {text: "Usuario", value: "username"};
      commit(SET_DOCUMENTS_LIST_HEADERS_ELEM, elem);
    }

    if (rootGetters['me/userData']['available_features']['feature_can_mark_doc_as_punteado']) {
      elem = {text: "Punteado", value: "punteado"};
      commit(SET_DOCUMENTS_LIST_HEADERS_ELEM, elem);
    }
  });
};


const getFilters = ({ commit, state, dispatch }, filts) => {
  commit(SET_DOCUMENT_OPTIONS_PAGE, 1)
  commit(SET_CURRENT_FILTERS, { documentsListFilters: filts });
  dispatch("refreshData")
};

const generateFilters = ({ state, dispatch }) => {
  let filts = "";
  for (let filter in state.documentListFiltersData2) {
    if (state.documentListFiltersData2[filter].value) {
      if (state.metadataFiltersStates.includes(state.selectedStateChip)) {
        filts += "&" + filter + "=" + encodeURIComponent(state.documentListFiltersData2[filter].value);
      } else {
        if (!['invoice_date__lte', 'invoice_date__gte'].includes(filter)) {
          filts += "&" + filter + "=" + encodeURIComponent(state.documentListFiltersData2[filter].value);
        }
      }
    }        
  }
  dispatch("getFilters", filts)
  // this.getFilters(filts);
};
const cleanFilters = ({ commit, dispatch }) => {
  commit(CLEAN_FILTERS);
  commit(SET_DOCUMENT_KIND, '');
  dispatch("getFilters", "");
};

const massiveUpdateObject = ({ state, rootGetters }, { url, ids, send_filters, params, currentCompany }) => {
  return new Promise((resolve, reject)=> {
    let values = { 
      'params': params, 
      'currentCompany':currentCompany 
    };
    if (send_filters) {
      values = get_queryset_filters(state, rootGetters, values);
    } else {
      values['ids'] = ids;
    }
    client.patch(url, values).then(response => {
      resolve(response);
    }).catch(err=>{
      reject(err);
    });
  });
};
     
const getMirrorDocument = ({}, { doc_id, session_username }) => {
  let params = {
    'doc_id': doc_id,
    'session_username': session_username,
  };
  return new Promise((resolve, reject) => {
    client.post('get_mirror_document/', params).then(resp => {
      resolve(resp);
    }).catch(err => {
      reject(err);
    });
  });
};

const getSimulatedMirrorDocument = ({}, { doc_id, session_username }) => {
  let params = {
    'doc_id': doc_id,
    'session_username': session_username,
  };
  return new Promise((resolve, reject) => {
    client.post('get_simulated_mirror_document/', params).then(resp => {
      resolve(resp);
    }).catch(err => {
      reject(err);
    });
  });
};

const getSimulationsFromTrainingDocument = ({}, { doc_id }) => {
  return new Promise((resolve, reject) => {
    client.get('get_simulation_documents/?doc_id=' + doc_id).then(resp => {
      resolve(resp);
    }).catch(err => {
      reject(err);
    });
  });
};

const markDocsAsPendingReview = ({ state, rootGetters }, { send_filters, docs }) => {
  return new Promise((resolve, reject) => {
    let params = {};
    if (send_filters) {
      params = get_queryset_filters(state, rootGetters, params);
    } else {
      params['doc_ids'] = docs;
    }
    client.post('mark_doc_as_pending_review/', params).then(resp => {
      resolve(resp);
    }).catch(err => {
      reject(err);
    })
  })
};

const forceDocsStateToDone = ({ state, rootGetters }, { send_filters, docs }) => {
  return new Promise((resolve, reject) => {
    let params = {};
    if (send_filters) {
      params = get_queryset_filters(state, rootGetters, params);
    } else {
      params['doc_ids'] = docs;
    }
    client.post('force_docs_done_state/', params).then(resp => {
      resolve(resp);
    }).catch(err => {
      reject(err);
    });
  });
};

const forceDocsSendInvoice = ({ state, rootGetters }, { send_filters, docs}) => {
  return new Promise((resolve, reject) => {
    let params = {};
    
    params['doc_ids'] = docs;
    client.post('documents/' + docs[0] +'/sync_document/', params).then(resp => {
      resolve(resp);
    }).catch(err => {
      reject(err);
    });
  });
};

const bckPendingReviewAction = ({ state, rootGetters }, { send_filters, docs }) => {
  return new Promise((resolve, reject) => {
    let params = {};
    if (send_filters) {
      params = get_queryset_filters(state, rootGetters, params);
    } else {
      params['doc_ids'] = docs;
    }
    client.post('back_doc_to_pending_review_state/', params).then(resp => {
      resolve(resp);
    }).catch(err => {
      reject(err);
    });
  }); 
};

const accountingToPendingReviewAction = ({ state, rootGetters }, { send_filters, docs }) => {
  return new Promise((resolve, reject) => {
    let params = {};
    if (send_filters) {
      params = get_queryset_filters(state, rootGetters, params);
    } else {
      params['doc_ids'] = docs;
    }
    client.post('accounting_to_pending_review_state/', params).then(resp => {
      resolve(resp);
    }).catch(err => {
      reject(err);
    });
  });
};

const backPendingUploadToPendingReview = ({ state, rootGetters }, { send_filters, docs }) => {
  return new Promise((resolve, reject) => {
    let params = {};
    if (send_filters) {
      params = get_queryset_filters(state, rootGetters, params);
    } else {
      params['docs_ids'] = docs;
    }
    client.post('back_pending_upload_to_pending_review/', params).then(response => {
      resolve(response);
    }).catch(error => {
      reject(error);
    });
  });
};

const changeStatePendingSyncToDone = ({ state, rootGetters }, { send_filters, docs }) => {
  return new Promise((resolve, reject) => {
    let params = {};
    if (send_filters) {
      params = get_queryset_filters(state, rootGetters, params);
    } else {
      params['doc_ids'] = docs;
    }
    client.post('change_doc_pending_sync_to_done/', params).then(response => {
      resolve(response);
    }).catch(error => {
      reject(error);
    });
  });
};

const changeStateErrorAlreadyDestinationToDone = ({ state, rootGetters }, { send_filters, docs }) => {
  return new Promise((resolve, reject) => {
    let params = {};
    if (send_filters) {
      params = get_queryset_filters(state, rootGetters, params);
    } else {
      params['doc_ids'] = docs;
    }
    client.post('docs_error_already_destination_to_done/', params).then(response => {
      resolve(response);
    }).catch(error => {
      reject(error);
    });
  });
};

const changeStateErrorAlreadyDestinationToPendingReview = ({ state, rootGetters }, { send_filters, docs }) => {
  return new Promise((resolve, reject) => {
    let params = {};
    if (send_filters) {
      params = get_queryset_filters(state, rootGetters, params);
    } else {
      params['doc_ids'] = docs;
    }
    client.post('docs_error_already_destination_to_pending_review/', params).then(response => {
      resolve(response);
    }).catch(error => {
      reject(error);
    });
  });
};

const changeStatePendingReviewToDone = ({ state, rootGetters }, { send_filters, docs }) => {
  return new Promise((resolve, reject) => {
    let params = {};
    if (send_filters) {
      params = get_queryset_filters(state, rootGetters, params);
    } else {
      params['doc_ids'] = docs;
    }
    client.post('docs_pending_review_to_done/', params).then(response => {
      resolve(response);
    }).catch(error => {
      reject(error);
    });
  });
};

const changeStateAccountingToPendingConnect = ({ state, rootGetters }, { send_filters, docs, session_username }) => {
  return new Promise((resolve, reject) => {
    let params = { 'session_username': session_username };
    if (send_filters) {
      params = get_queryset_filters(state, rootGetters, params);
    } else {
      params['doc_ids'] = docs;
      if (rootGetters.getCurrentCompany) {
        params['cdb'] = rootGetters.getCurrentCompany.id;
      } else if (rootGetters["me/userData"].companydb) {
        params['cdb'] = rootGetters["me/userData"].companydb;
      }
    }
    client.post('docs_accounting_to_pending_connect/', params).then(response => {
      resolve(response);
    }).catch(error => {
      reject(error);
    });
  });
};

const changeStatePendingConnectToPendingReview = ({ state, rootGetters }, { send_filters, docs, session_username }) => {
  return new Promise((resolve, reject) => {
    let params = { 'session_username': session_username };
    if (send_filters) {
      params = get_queryset_filters(state, rootGetters, params);
    } else {
      params['doc_ids'] = docs;
      if (rootGetters.getCurrentCompany) {
        params['cdb'] = rootGetters.getCurrentCompany.id;
      } else if (rootGetters["me/userData"].companydb) {
        params['cdb'] = rootGetters["me/userData"].companydb;
      }
    }
    client.post('docs_pending_connect_to_pending_review/', params).then(response => {
      resolve(response);
    }).catch(error => {
      reject(error);
    });
  })
}

const changeStateAccountingToDone = ({ state, rootGetters }, { send_filters, docs, session_username }) => {
  return new Promise((resolve, reject) => {
    let params = { 'session_username': session_username };

    if (send_filters) {
      params = get_queryset_filters(state, rootGetters, params);
    } else {
      params['doc_ids'] = docs;
      if (rootGetters.getCurrentCompany) {
        params['cdb'] = rootGetters.getCurrentCompany.id;
      } else if (rootGetters["me/userData"].companydb) {
        params['cdb'] = rootGetters["me/userData"].companydb;
      }
    }

    console.log(params)
    client.post('docs_accounting_to_done/', params).then(response => {
      resolve(response);
    }).catch(error => {
      reject(error);
    })
  })
}

const generatePaymentMoves = ({ state, rootGetters }, { send_filters, docs }) => {
  return new Promise((resolve, reject) => {
    let params = {};
    if (send_filters) {
      params = get_queryset_filters(state, rootGetters, params);
    } else {
      params['doc_ids'] = docs;
    }
    client.post('generate_payment_moves/', params).then(response => {
      resolve(response);
    }).catch(error => {
      reject(error);
    });
  });
}

const createManualPaymentMoves = ({dispatch, state}, params) => {
  return new Promise((resolve, reject) => {
    client.post('create_manual_payment_moves/', params).then(r => { 
      dispatch("documents/fetchDocument", { id: state.id }, { root: true }).then(()=>{
        resolve(r) 
      }).catch(err => {
        reject(err);
      });
    }).catch(err => {
      reject(err);
    });
  });
};

const downloadCSV = ({ rootState }, docs) => {
  return new Promise((resolve, reject) => {
    let ids = [];
    for (let doc in docs) {
      ids.push(docs[doc].id);
    }
    client.post('download_csv/', {'cdb': rootState.currentCompany.id, 'ids': ids}).then(resp => {
      resolve(resp);
    }).catch(err => {
      console.debug(err);
      reject(err);
    });
  });
}

const downloadCSVOneLine = ({ state, rootGetters, rootState }, { send_filters, docs, options, state_filter }) => {
  return new Promise((resolve, reject) => {
    let params = { 'cdb': rootState.currentCompany.id };
    if (send_filters) {
      params = get_queryset_filters(state, rootGetters, params);
    } else {
      let ids = [];
      for (let doc in docs) {
        ids.push(docs[doc].id);
      }
      params['ids'] = ids;
    }
    if (state_filter) {
      params['state_filter'] = state_filter;
    }

    const { sortBy, sortDesc } = options;
    let sortField = false;
    let sortOrder = false;
    if(sortBy){
      sortField = sortBy[0];
    }
    if(sortDesc){
      sortOrder = sortDesc[0];
    }
    params['sortField']=sortField;
    params['sortOrder']=sortOrder;

    client.post('download_csv_one_line/', params).then(resp => {
      resolve(resp);
    }).catch(err => {
      console.debug(err);
      reject(err);
    });
  });
}

const toDone = ({ state, rootGetters, rootState }, { send_filters, docs, last_entry_number_csv }) => {
  return new Promise((resolve, reject) => {
    let params = { 'cdb': rootState.currentCompany.id, 'last_entry_number_csv': last_entry_number_csv };
    if (send_filters) {
      params = get_queryset_filters(state, rootGetters, params);
    } else {
      let ids = [];
      for (let doc in docs) {
        ids.push(docs[doc].id);
      }
      params['ids'] = ids;
    }

    client.post('docs_to_done/', params).then(resp => {
      resolve(resp);
    }).catch(err => {
      console.debug(err);
      reject(err);
    });
  });
}

const getHeaderUser = ({ commit, rootState, rootGetters }) => {
  return new Promise((resolve, reject) => {
    client.get('settings/get_document_list_headers/').then(resp => {
      commit(SET_DOCUMENTS_LIST_HEADERS_USER, resp.data['show']);
      commit(SET_DOCUMENT_LIST_HIDDEN_HEADERS_USER, resp.data['hide']);
      resolve();
    }).catch(err => {
      console.debug(err);
      reject(err);
    });
  });
}

const getHeader = ({ commit, rootState, rootGetters }) => {
  return new Promise((resolve, reject) => {
    let cdb_id = '';
    if (rootGetters['me/userData']['companydb']){
      cdb_id = rootGetters['me/userData']['companydb']['id'];
    } else if (rootState && rootState.currentCompany) {
      cdb_id = rootState.currentCompany.id;
    }
    if (cdb_id) {
      client.get('settings/get_document_list_headers/?cdb_id=' + cdb_id).then(resp => {
        commit(SET_DOCUMENTS_LIST_HEADERS, resp.data['show']);
        commit(SET_DOCUMENT_LIST_HIDDEN_HEADERS, resp.data['hide']);
        resolve();
      }).catch(err => {
        console.debug(err);
        reject(err);
      });
      client.get('settings/get_document_list_headers_read_only/?cdb_id=' + cdb_id).then(resp => {
        commit(SET_DOCUMENTS_LIST_HEADERS_READ_ONLY, resp.data['show']);
        commit(SET_DOCUMENT_LIST_HIDDEN_HEADERS_READ_ONLY, resp.data['hide']);
        resolve();
      }).catch(err => {
        console.debug(err);
        reject(err);
      });
    } else {
      reject();
    }
  });
}
const setHeaderUser = ({ state, rootState, rootGetters}) => {
  return new Promise((resolve, reject) => {
    let url = 'settings/set_setting/document_list_headers/' + rootGetters["me/userData"]['user'] + '/';
    let params = { 'payload': { 'show': state.documentListHeadersUser, 'hide': state.documentListHiddenHeadersUser }};
    client.patch(url, params).then(() => {
      resolve();
    }).catch(err => {
      console.debug(err);
      reject(err);
    });
  });
}
const setHeader = ({ state, rootState, rootGetters}) => {
  return new Promise((resolve, reject) => {
    let cdb_id = '';
    if (rootGetters['me/userData']['companydb']){
      cdb_id = rootGetters['me/userData']['companydb']['id'];
    } else {
      cdb_id = rootState.currentCompany.id;
    }
    let url = 'settings/set_setting/document_list_headers/' + rootGetters["me/userData"]['user'] + '/' + cdb_id + '/';
    let params = { 'payload': { 'show': state.documentListHeaders, 'hide': state.documentListHiddenHeaders }};
    client.patch(url, params).then(() => {
      resolve();
    }).catch(err => {
      console.debug(err);
      reject(err);
    });
  });
}
const setHeaderReadOnly = ({ state, rootState, rootGetters }) => {
  return new Promise((resolve, reject) => {
    let cdb_id = '';
    if (rootGetters['me/userData']['companydb']){
      cdb_id = rootGetters['me/userData']['companydb']['id'];
    } else {
      cdb_id = rootState.currentCompany.id;
    }
    let url = 'settings/set_setting/document_list_headers_read_only/' + rootGetters["me/userData"]['user'] + '/' + cdb_id + '/';
    let params = { 'payload': { 'show': state.documentListHeadersReadOnly, 'hide': state.documentListHiddenHeadersReadOnly }};
    client.patch(url, params).then(() => {
      resolve();
    }).catch(err => {
      console.debug(err);
      reject(err);
    });
  });
}
const getHeaderSupplierDBUser = ({ commit, rootState, rootGetters }) => {
  return new Promise((resolve, reject) => {
    let cdb_id = false;
    if (rootGetters['me/userData']['companydb']){
      cdb_id = rootGetters['me/userData']['companydb']['id'];
    } else if(rootState && rootState.currentCompany) {
      cdb_id = rootState.currentCompany.id;
    }
    let url = 'settings/get_supplierdb_list_headers/';
    if (cdb_id) {
      url += '?cdb_id='+cdb_id
    }
    client.get(url).then(resp => {
      commit(SET_SUPPLIERDB_LIST_HEADERS_USER, resp.data['show']);
      commit(SET_SUPPLIERDB_LIST_HIDDEN_HEADERS_USER, resp.data['hide']);
      resolve();
    }).catch(err => {
      console.debug(err);
      reject(err);
    });
  });
}
const setHeaderSupplierDBUser = ({ state, rootState, rootGetters}) => {
  return new Promise((resolve, reject) => {
    let url = 'settings/set_setting/supplierdb_list_headers/' + rootGetters["me/userData"]['user'] + '/';
    let params = { 'payload': { 'show': state.supplierdbListHeadersUser, 'hide': state.supplierdbListHiddenHeadersUser }};
    client.patch(url, params).then(() => {
      resolve();
    }).catch(err => {
      console.debug(err);
      reject(err);
    });
  });
}

const getHeaderCustomerDBUser = ({ commit, rootState, rootGetters }) => {
  return new Promise((resolve, reject) => {
    let cdb_id = false;
    if (rootGetters['me/userData']['companydb']){
      cdb_id = rootGetters['me/userData']['companydb']['id'];
    } else if(rootState && rootState.currentCompany) {
      cdb_id = rootState.currentCompany.id;
    }
    let url = 'settings/get_customerdb_list_headers/';
    if (cdb_id) {
      url += '?cdb_id='+cdb_id
    }
    client.get(url).then(resp => {
      commit(SET_CUSTOMERDB_LIST_HEADERS_USER, resp.data['show']);
      commit(SET_CUSTOMERDB_LIST_HIDDEN_HEADERS_USER, resp.data['hide']);
      resolve();
    }).catch(err => {
      console.debug(err);
      reject(err);
    });
  });
}

const setHeaderCustomerDBUser = ({ state, rootState, rootGetters}) => {
  return new Promise((resolve, reject) => {
    let url = 'settings/set_setting/customerdb_list_headers/' + rootGetters["me/userData"]['user'] + '/';
    let params = { 'payload': { 'show': state.customerdbListHeadersUser, 'hide': state.customerdbListHiddenHeadersUser }};
    client.patch(url, params).then(() => {
      resolve();
    }).catch(err => {
      console.debug(err);
      reject(err);
    });
  });
}

const addMetadataDetailLine = ({state,commit, rootState, rootGetters}, {line, label}) => {
  //console.log('new LINE', line, label)
  var value = [];
  if (state.document.metadata[label]) {
    for(var i = 0; i < state.document.metadata[label].length; i++) {
      value.push(state.document.metadata[label][i])
    }
  }
  value.push(line)
  //console.log('sending', value)
  commit('updateMetadataField', {value: value, path: label});
}

  

const remMetadataDetailLine = ({state,commit, rootState, rootGetters}, {pos, label}) => {
  var value = [];
  if (state.document.metadata[label]) {
    for(var i = 0; i < state.document.metadata[label].length; i++) {
      value.push(state.document.metadata[label][i])
    }
    value.splice(pos,1)
    commit('updateMetadataField', {value: value, path: label});
  }
}

const updateMetadataFieldAct = ({state,commit, rootState, rootGetters}, {label,value}) => {
  //console.log('action!')
  commit('updateMetadataField', {value: value, path: label});
}

const getFiltersParamsForRequest = ({ state, rootGetters }, params) => {
  return new Promise((resolve, reject) => {
    let new_params = get_queryset_filters(state, rootGetters, params);
    resolve(new_params);
  });
}

const setAllDataFilters = ({state, rootState, rootGetters, dispatch, commit}, filtersUrl) => {
  if (filtersUrl) {
    try {
      let urlParams = new URLSearchParams(filtersUrl)
      let filters = Object.fromEntries(urlParams)
      let keys = Object.keys(state.documentListFiltersData2);
      for(var i = 0; i < keys.length; i++) {
        let key = keys[i];
        if (filters[key]) {
          commit(SET_BROWSER_VALUE, {key: key, value: filters[key]});
        } 
      }
    } catch {}
  }
}

const initAllCurrentsFilters = ({state, rootState, rootGetters, dispatch, commit}) => {
  let itemsPerPage = 10
  commit(SET_DOCUMENT_LIST_OPTIONS, {page: 1, itemsPerPage: itemsPerPage, sortBy: [], sortDesc: []});
  commit(SET_CURRENT_FILTERS, { documentsListFilters: '' });
  commit(SET_DOCUMENT_KIND, '');
  commit(SET_STATES_FILTER, undefined);
  commit(SET_DOCUMENTS_LIST_ID, null);
  commit(SET_ITEMS_PER_PAGE, itemsPerPage);
  var keys = Object.keys(state.documentListFiltersData2);
  for (var i = 0; i < keys.length; i++) {
      let data = {key: keys[i], value: ''};
      commit(SET_FILTERS_DATA_KEY, data);
  }
};

const setAllCurrentsFilters  = ({state, rootState, rootGetters, dispatch, commit}, get_data) => {
  let company = rootGetters.getCurrentCompany;
  if (!company) {
    company = {
      id: rootGetters['setting_repository/currentKey']
    };
  }
  if (company) {
    dispatch('initAllCurrentsFilters');
    let filters = rootGetters['setting_repository/getSettings'](company.id);
    if (filters && get_data) {
      let itemsPerPage = 10
      if (filters.itemsPerPage) {
        itemsPerPage = filters.itemsPerPage;
      }
      const params = { 
        page: filters.page, 
        itemsPerPage: itemsPerPage, 
        sortBy: [], 
        sortDesc: [],
        groupBy: [],
        groupDesc: [],
        mustSort: false,
        multiSort: false
      };
      if (filters.sortField) {
        params.sortBy.push(filters.sortField);
      }
      if (filters.sortOrder && filters.sortField) {
        params.sortDesc.push(true);
      } else {
        params.sortDesc.push(false);
      } 
      commit(SET_DOCUMENT_LIST_OPTIONS, params);
      commit(SET_CURRENT_FILTERS, { documentsListFilters: filters.filters });
      commit(SET_DOCUMENT_KIND, filters.kind);
      if (filters.statesFilter && filters.statesFilter.length > 0) {
        commit(SET_STATES_FILTER, filters.statesFilter);
      }
      commit(SET_DOCUMENTS_LIST_ID, filters.documentsListId);
      commit(SET_ITEMS_PER_PAGE, itemsPerPage);
      if (filters.filters) {
        dispatch('setAllDataFilters', filters.filters);
      }
    } else if (!get_data) { // TODO: revisar si este es el mejor sitio para aplicar este filtro
      let current_ejercicio = {};
      for (let i in company.links) {
        if (company.links[i].active) {
          if (!Object.keys(current_ejercicio).includes('min_date') || current_ejercicio['min_date'] < company.links[i].min_date) {
            current_ejercicio = company.links[i];
          }
        }
      }
      if (Object.keys(current_ejercicio).includes('id')) {
        let filter = '&ejercicio=' + current_ejercicio.id;
        commit(SET_CURRENT_FILTERS, { documentsListFilters: filter });
        dispatch('setAllDataFilters', filter);
      }
    }
  }
}

const setCurrentStateChip = ({state, rootState, rootGetters, dispatch, commit}, get_data) => {
  let company = rootGetters.getCurrentCompany;
  if (!company) {
    company = {
      id: rootGetters['setting_repository/currentKey']
    };
  }
  if (company) {
    let key = rootGetters['setting_repository/keyStateChip'] + company.id;
    let value = rootGetters['setting_repository/getSettings'](key);
    let filters = rootGetters['setting_repository/getSettings'](company.id);
    if (value && filters && get_data) { //TODO revisar desactivar && False
      commit(SET_SELECTED_STATE_CHIP, value);
    } else {
      if (value) {
        dispatch('setting_repository/removeSettings', {settings: key}, { root: true })
      }
      commit(SET_SELECTED_STATE_CHIP, 'all');
    }
  }
};

const getDocumentActionsErrorParams = ({ commit, rootGetters }) => {
  return new Promise((resolve, reject) => {
    let url = 'settings/get_setting/document_actions_params/' + rootGetters["me/userData"]['user'] + '/';
    client.get(url).then(resp => {
      commit(SET_DOCUMENT_ACTIONS_ERROR_PARAMS, resp.data['params']);
      resolve();
    }).catch(err => {
      console.debug(err);
      reject(err);
    });
  });
};

const fixContasolDocuments = ({ state, rootGetters }, { send_filters, docs }) => {
  return new Promise((resolve, reject) => {
    let params = {};
    if (send_filters) {
      params = get_queryset_filters(state, rootGetters, params);
    } else {
      params['doc_ids'] = docs;
      let currentCompanyId;
      if (rootGetters.getCurrentCompany) {
        currentCompanyId = rootGetters.getCurrentCompany.id;
      } else if (rootGetters["me/userData"].companydb) {
        currentCompanyId = rootGetters["me/userData"].companydb;
      }
      params['cdb'] = currentCompanyId;
    }
    client.post('fix_contasol_documents/', params).then(response => {
      resolve(response);
    }).catch(error => {
      reject(error);
    });
  });
};

const setColumnDataIfParams = ({ commit },data) => {
  if(data['params']){
    if(data['params']['show']){
      commit(SET_DOCUMENTS_LIST_HEADERS, data['params']['show']);
    }
    if(data['params']['hide']){
      commit(SET_DOCUMENT_LIST_HIDDEN_HEADERS, data['params']['hide']);
    }  
  }
}

const getCompanyActivities = ({ state }, { companydb_id, feature_code, field_show }) => {
  return new Promise((resolve, reject) => {
    let params = {
      'companydb_id': companydb_id,
      'code': feature_code,
      'field_show': field_show,
    };
    client.get('is_active_feature/', {params: params}).then(response => {
      let is_active = response.data.is_active;
      if (is_active) {
        let params2 = {'companydb_id': companydb_id}
        client.get('activities/', {params: params2}).then(response => {
          resolve(response.data.results);
        }).catch(err => {
          reject(err);
        });
      }
      else {
        resolve([]);
      }
    }).catch(err => {
      reject(err);
    });
  });
}

const showAccountMoveFooter = ({ state, commit }) => {
  commit(SET_ACCOUNT_MOVE_LINES, { min_footer: false, footer_height: 370 })
  commit(SET_LAST_SHOW_ACCOUNT_MOVE, true);
};

const hideAccountMoveFooter = ({ state, commit }) => {
  commit(SET_ACCOUNT_MOVE_LINES, { min_footer: true, footer_height: 60 })
  commit(SET_LAST_SHOW_ACCOUNT_MOVE, false);
};

const showInvoiceLinesFooter = ({ state, commit }) => {
  commit(SET_INVOICE_LINES, { show_invoice_lines: true, footer_height: 370 })
  commit(SET_LAST_SHOW_INVOICE_LINES, true);
};

const hideInvoiceLinesFooter = ({ state, commit }) => {
  commit(SET_INVOICE_LINES, { show_invoice_lines: false, footer_height: 60 })
  commit(SET_LAST_SHOW_INVOICE_LINES, false);
};

const initAccountMoveFooter = ({ state, commit }, account_move) => {
  if (account_move) {
    if (state.linesAccountMove.last_option.show) {
      commit(SET_ACCOUNT_MOVE_LINES, { min_footer: false, footer_height: 370 })
    } else {
      commit(SET_ACCOUNT_MOVE_LINES, { min_footer: true, footer_height: 60 })
    }
  } else {
    commit(SET_ACCOUNT_MOVE_LINES, { min_footer: true, footer_height: 60 })
  }
}

const initInvoiceLinesFooter = ({ state, commit }, invoice_line) => {
  if (invoice_line) {
    if (state.invoiceLines.last_option.show) {
      commit(SET_INVOICE_LINES, { min_footer: false, footer_height: 370 })
    } else {
      commit(SET_INVOICE_LINES, { min_footer: true, footer_height: 60 })
    }
  } else {
    commit(SET_INVOICE_LINES, { min_footer: true, footer_height: 60 })
  }
}

const initInvoiceLines = ({ state, commit }, account_move) => {
  
  if (state.invoiceLines.last_option.show) {
    commit(SET_INVOICE_LINES, { show_invoice_lines: false, invoice_lines_height: 370 })
  } else {
    commit(SET_INVOICE_LINES, { show_invoice_lines: true, invoice_lines_height: 60 })
  }
  
}

// Barra de filtros nueva
const updateObject = ({commit}, {key,value,text}) => {
  if(key=='ejercicio')
    commit(SET_FILTER_EJERCICIO, {value, text});
  if(key=='id')
    commit(SET_FILTER_ID, value);
  if(key=='state')
    commit(SET_FILTER_STATE, {value,text});
  if(key=='search__icontains')
    commit(SET_FILTER_SEARCH_ICONTAINS, value);
  if(key=='search__duplicate')
    commit(SET_FILTER_SEARCH_DUPLICATE, value);
  if(key=='document_text__icontains')
    commit(SET_FILTER_DOCUMENT_TEXT_ICONTAINS, value);
  if(key=='tags')
    commit(SET_FILTER_TAGS, value);
  if(key=='actividad')
    commit(SET_FILTER_ACTIVIDAD, value);
  if(key=='actividad_str')
    commit(SET_FILTER_ACTIVIDAD_STR, value);
  if(key=='username__icontains')
    commit(SET_FILTER_USERNAME_ICONTAINS, value);
  if(key=='kind')
    commit(SET_FILTER_KIND, {value,text});
  if(key=='created__gte')
    commit(SET_FILTER_CREATED_GTE, value);
  if(key=='created__lte')
    commit(SET_FILTER_CREATED_LTE, value);
  if(key=='accounting_date__gte')
    commit(SET_FILTER_ACCOUNTING_DATE_GTE, value);
  if(key=='accounting_date__lte')
    commit(SET_FILTER_ACCOUNTING_DATE_LTE, value);
  if(key=='invoice_date__gte')
    commit(SET_FILTER_INVOICE_DATE_GTE, value);
  if(key=='invoice_date__lte')
    commit(SET_FILTER_INVOICE_DATE_LTE, value);
  if(key=='third_cif__icontains')
    commit(SET_FILTER_THIRD_CIF_ICONTAINS, value);
  if(key=='third_name__icontains')
    commit(SET_FILTER_THIRD_NAME_ICONTAINS, value);
  if(key=='mirror_state')
    commit(SET_FILTER_MIRROR_STATE, {value,text});
  if(key=='punteado')
    commit(SET_FILTER_PUNTEADO, {value,text});
  if(key=='is_rectificativa')
    commit(SET_FILTER_RECTIFICATIVA, {value,text});
  if(key=='payment_state')
    commit(SET_FILTER_PAYMENT_STATE, {value,text});
  if(key=='payment_date__gte')
    commit(SET_FILTER_PAYMENT_DATE_GTE, value);
  if(key=='payment_date__lte')
    commit(SET_FILTER_PAYMENT_DATE_LTE, value);
  if(key=='has_retention')
    commit(SET_FILTER_HAS_RETENTION, {value,text});
  if(key=='notes__icontains')
    commit(SET_FILTER_NOTES_ICONTAINS, value);
};

// Barra de filtros nueva
const removeAllFilters = ({commit},p) => {
  let value=''
  let text=''
  commit(SET_FILTER_EJERCICIO, {value, text});
  commit(SET_FILTER_ID, value);
  commit(SET_FILTER_STATE, {value,text});
  commit(SET_FILTER_SEARCH_ICONTAINS, value);
  commit(SET_FILTER_SEARCH_DUPLICATE, value);
  commit(SET_FILTER_DOCUMENT_TEXT_ICONTAINS, value);
  commit(SET_FILTER_TAGS, value);
  commit(SET_FILTER_ACTIVIDAD, value);
  commit(SET_FILTER_ACTIVIDAD_STR, value);
  commit(SET_FILTER_USERNAME_ICONTAINS, value);
  commit(SET_FILTER_KIND, {value,text});
  commit(SET_FILTER_CREATED_GTE, value);
  commit(SET_FILTER_CREATED_LTE, value);
  commit(SET_FILTER_ACCOUNTING_DATE_GTE, value);
  commit(SET_FILTER_ACCOUNTING_DATE_LTE, value);
  commit(SET_FILTER_INVOICE_DATE_GTE, value);
  commit(SET_FILTER_INVOICE_DATE_LTE, value);
  commit(SET_FILTER_THIRD_CIF_ICONTAINS, value);
  commit(SET_FILTER_THIRD_NAME_ICONTAINS, value);
  commit(SET_FILTER_MIRROR_STATE, {value,text});
  commit(SET_FILTER_PUNTEADO, {value,text});
  commit(SET_FILTER_RECTIFICATIVA, {value,text});
  commit(SET_FILTER_PAYMENT_STATE, {value,text});
  commit(SET_FILTER_PAYMENT_DATE_GTE, value);
  commit(SET_FILTER_PAYMENT_DATE_LTE, value);
  commit(SET_FILTER_HAS_RETENTION, {value,text});
  commit(SET_FILTER_NOTES_ICONTAINS, value);
}

export const actions = {
  fetchDocument,
  continueFlow,
  cancelEditFlow,
  deleteLabel,
  downloadMergedDocuments,
  selectLabel,
  saveLabels,
  setSelectedText,
  nextLabel,
  previousLabel,
  incLabel,
  end,
  resetDocument,
  setCurrentDocs,
  updateCurrentIndex,
  setCurrentIndex,
  setCurrentFilters,
  setCurrentLoading,
  setCurrentOptions,
  setCurrentPage,
  setItemsLength,
  setDictBoolStates,
  setDictBoolTags,
  setFiltersLoaded,
  refreshData,
  setFiltersDataStatesValues,
  setFiltersDataTagsValues,
  setFiltersDataActividadStrValues,
  setFiltersDataActividadValues,
  setFilterDataEjercicioValue,
  setFilterDataProjectValue,
  setFiltersDataIdValue,
  setFiltersDataStateValue,
  setFiltersDataSearchValue,
  setFiltersDataSearchDuplicateValue,
  setFilterDataEjercicioUserValues,
  setDocumentKind,
  setFiltersDataTagsValue,
  setFiltersDataEntryNumberValue,
  setFiltersDataAccountMoveNumberValue,
  setIsTrainerMode,
  setIsDebuggerMode,
  setForcedMove,
  saveAccountMoves,
  fetchDocumentMetadata,
  checkSum,
  downloadFile,
  downloadFiles,
  multiContinueFlow,
  multiRetryAll,
  setAnnotationLayer,
  setZoom,
  setRotation,
  setRotationMode,
  doRotate,
  cancelRotationMode,
  saveRotation,
  massiveRotation,
  massiveCalculateBaseCuota,
  massiveFixRound,
  massiveFixMismatchEx0,
  massiveForceSendDocuments,
  setIntraDataFromThirdParty,
  setCriteriodeCaja,
  setIsComercianteMinorista,
  setInvNumberToRectify,
  setInvDateToRectify,
  setIntraDataFromCustom,
  setType0,
  setDirty,
  setItemsPerPage,
  setCurrentDocumentSupplierDB,
  setCurrentDocumentCustomerDB,
  setCurrentHeaders,
  downloadFormationDocuments,
  downloadExcel,
  getFilters,
  generateFilters,
  cleanFilters,
  documentToParam,
  downloadCSV,
  downloadCSVOneLine,
  toDone,
  massiveUpdateObject,
  getMirrorDocument,
  getSimulatedMirrorDocument,
  getSimulationsFromTrainingDocument,
  markDocAsErrorAccountConnector,
  markDocsAsPendingReview,
  forceDocsStateToDone,
  bckPendingReviewAction,
  accountingToPendingReviewAction,
  backPendingUploadToPendingReview,
  changeStatePendingSyncToDone,
  changeStateErrorAlreadyDestinationToDone,
  changeStateErrorAlreadyDestinationToPendingReview,
  changeStatePendingReviewToDone,
  changeStateAccountingToPendingConnect,
  changeStatePendingConnectToPendingReview,
  changeStateAccountingToDone,
  generatePaymentMoves,
  createManualPaymentMoves,
  markAsPunteado,
  markAsDespunteado,
  setNeedsTtFixState,
  getRetryDetectionStates,
  getHeader,
  getHeaderUser,
  setHeader,
  setHeaderUser,
  getHeaderSupplierDBUser,
  setHeaderSupplierDBUser,
  getHeaderCustomerDBUser,
  setHeaderCustomerDBUser,
  addMetadataDetailLine,
  remMetadataDetailLine,
  updateMetadataFieldAct,
  setHeaderReadOnly,
  getFiltersParamsForRequest,
  dinamic_get_list_documents,
  initAllCurrentsFilters,
  setAllCurrentsFilters,
  setAllDataFilters,
  setCurrentStateChip,
  getDocumentActionsErrorParams,
  fixContasolDocuments,
  getTextTagging,
  setColumnDataIfParams,
  saveDocWithoutContinueFlow,
  updateAutomaticMoveAccounts,
  getCompanyActivities,
  showAccountMoveFooter,
  hideAccountMoveFooter,
  initAccountMoveFooter,
  initInvoiceLines,
  hideInvoiceLinesFooter,
  initInvoiceLinesFooter,
  showInvoiceLinesFooter,
  forceDocsSendInvoice,
  updateObject,
  removeAllFilters,
}


// mutations
const mutations = {
  [SET_DOC_ID](state, { id }) {
    state.id = id
  },
  [SET_DOC_STATE](state, { state: doc_state }) {
    if (state.document) {
      state.document.state = doc_state
    }
  },
  [SET_CURRENT_DOCUMENTS](state, { docs }) {
    state.documents = docs
  },
  [SET_LOADING_INFO](state, {info}){
    state.loading_info = info
  },
  [SET_DINAMIC_CALL_ID](state, {id}){
    state.dinamic_call_id = id
  },
  [RESET_DOC](state) {
    state.docLoading = false;
    state.docError = false;
    state.document = undefined;
    state.docState = undefined
    state.dirty = false
  },
  [FETCH_DOC_SUCCESS](state, { document }) {
    state.docLoading = false;
    state.docError = false;
    if(state.document && state.document.id==document.id){
      document.textTagging = state.document.textTagging
    }
    state.document = { ...document };
    state.docState = [{'value': state.document.state,'text':state.document.state_display}]
    state.dirty = false
  },
  [DOCUMENT_TO_PARAM](state) {
    state.selectedIvaCheck = undefined
    if (state.document.inversion_sujeto_pasivo_iva) {
      state.selectedParam = 'inversion_sujeto_pasivo_iva';
      state.selectedParamOption = state.document.inversion_sujeto_pasivo_iva_percent;
    } else if (state.document.inversion_sujeto_pasivo_igic) {
      state.selectedParam = 'inversion_sujeto_pasivo_igic';
      state.selectedParamOption = state.document.inversion_sujeto_pasivo_igic_percent;
    } else if (state.document.intracomunitario) {
      state.selectedParam = 'intracomunitario';
      state.selectedParamOption = state.document.intracomunitario_percent;
      state.selectedParamOption2 = state.document.intracomunitario_type;
    } else if (state.document.extracomunitario) {
      state.selectedParam = 'extracomunitario';
      state.selectedParamOption = state.document.importaciones_percent;
      state.selectedParamOption2 = state.document.intracomunitario_type;
    } else if (state.document.is_comerciante_minorista) {
      state.selectedParam = 'is_comerciante_minorista';
      state.selectedParamOption = state.document.is_comerciante_minorista_percent;
    } else{
      let nsCount = 0;
      let neCount = 0;
      let dryCount = 0;

      // Iterate through the keys of the object
      for (let key in state.document.metadata) {
          if (key.includes("_ns_0")) {
            nsCount++;
          } else if (key.includes("_ne_0")) {
            neCount++;
          } else if (key.includes("_0")) {
            dryCount++;
          }
        }
      let maxCount = Math.max(nsCount, neCount, dryCount);
      if(maxCount == dryCount){
        state.selectedParam = undefined;
        state.selectedParamOption = undefined;
      }
      else if(maxCount == nsCount){
        state.selectedParam = 'no_sujeta';
        state.selectedParamOption = undefined;
      }
      else{
        state.selectedParam = 'dry_0_percent';
        state.selectedParamOption = undefined;
      }
    }

    //Get Iva check radiobuttons
    if (state.document.iva_igic_no_deducible) {
      state.selectedIvaCheck = 'iva_igic_no_deducible';
    }
    else if (state.document.gasto_iva_parcial) {
      state.selectedIvaCheck = 'gasto_iva_parcial';
    }
    else if (state.document.iva_parcial) {
      state.selectedIvaCheck = 'iva_parcial';
    }
    else if (state.document.prorate) {
      state.selectedIvaCheck = 'prorate';
    }
  },
  [SET_TEXT_TAGGING](state, { text_tagging,id }) {
    if(state && state.document && id == state.document.id){
      state.document.textTagging = text_tagging
    }
  },
  [FETCH_METADATA_SUCCESS](state, { document }) {
    if(document && state && state.document && document.id == state.document.id){
      state.docLoading = false;
      state.docError = false;
      state.docState = [{'value': document.state,'text':document.state_display}]
      state.document.state = document.state;
      state.document.state_display = document.state_display;
      state.document.metadata = document.metadata;
      state.document.tags = document.tags;
      state.document.supplierdb = document.supplierdb;
      state.document.customerdb = document.customerdb;
      state.document.accountMoves = document.accountMoves;
      state.document.async_job_state = document.async_job_state;
      state.document.errorJson = document.errorJson;
      state.document.inversion_sujeto_pasivo_iva = document.inversion_sujeto_pasivo_iva;
      state.document.inversion_sujeto_pasivo_iva_percent = document.inversion_sujeto_pasivo_iva_percent;
      state.document.inversion_sujeto_pasivo_igic = document.inversion_sujeto_pasivo_igic;
      state.document.inversion_sujeto_pasivo_igic_percent = document.inversion_sujeto_pasivo_igic_percent;
      state.document.intracomunitario = document.intracomunitario;
      state.document.intracomunitario_percent = document.intracomunitario_percent;
      state.document.intracomunitario_type = document.intracomunitario_type;
      state.document.extracomunitario = document.extracomunitario;
      state.document.is_comerciante_minorista_percent = document.is_comerciante_minorista_percent;
      state.document.is_comerciante_minorista = document.is_comerciante_minorista;
      state.document.no_sujeta = document.no_sujeta;
      state.document.bien_inversion = document.bien_inversion;
      state.document.written_description = document.written_description;
      state.document.description = document.description;
      state.document.importaciones_percent = document.importaciones_percent;
      state.document.iva_igic_no_deducible = document.iva_igic_no_deducible;
      state.document.gasto_iva_parcial = document.gasto_iva_parcial;
      state.document.iva_parcial = document.iva_parcial;
      state.document.comerciante_minorista = document.comerciante_minorista;
      state.document.gasto_iva_percent = document.gasto_iva_percent;
      state.document.prorate = document.prorate;
      state.document.actividad_str = document.actividad_str;
      state.document.building_code = document.building_code;
      state.document.apply_modelo = document.apply_modelo;
      state.document.apply_415 = document.apply_415;
      state.document.serie = document.serie;
      state.document.doc_number = document.doc_number;
      state.document.doc_number_prefix = document.doc_number_prefix;
      state.document.excel_line_index = document.excel_line_index;
      state.document.currency = document.currency;
      state.document.retention_type_name = document.retention_type_name,
      state.document.fiscal_location = document.fiscal_location;
      state.dirty = false
    }
  },
  [FETCH_DOC_BEGIN](state) {
    state.docLoading = true;
    state.docError = false;
    //state.document = undefined;
    // state.flowLoading = false;
  },
  [FETCH_DOC_ERROR](state) {
    state.docLoading = false;
    state.docError = true;
  },
  [WRITE_DOC_SUCCESS](state, { document }) {
    state.docWriteLoading = false;
    state.docWriteError = false;
    state.document = { ...document };
  },
  [WRITE_DOC_BEGIN](state) {
    state.docWriteLoading = true;
    state.docWriteError = false;
  },
  [WRITE_DOC_ERROR](state) {
    state.docWriteLoading = false;
    state.docWriteError = true;
  },
  [CONTINUE_FLOW_SUCCESS](state) {
    state.flowLoading = false;
    state.flowError = false;
  },
  [CONTINUE_FLOW_BEGIN](state) {
    state.flowLoading = true;
    state.flowError = false;
  },
  [CONTINUE_FLOW_ERROR](state) {
    state.flowLoading = false;
    state.flowError = true;
  },
  [SET_SELECTED_LABEL](state, { label }) {
    state.selectedLabel = label
  },
  [SET_DOC_LABEL](state, { label, index, annotationLayer }) {
    if(!state.document['textTagging'][state.currentPage-1][index].label){
      state.document['textTagging'][state.currentPage-1][index].label={}
    }
    state.document['textTagging'][state.currentPage-1][index].label[annotationLayer] = label;
    //state.document.metadata[label] = state.document['textTagging'][index]['word'];
  },
  [SET_SELECTED_TEXT](state, { index }) {
    state.selectedText = index;
  },
  [SET_CURRENT_INDEX](state, { index }) {
    state.index = index;
  },
  [SET_CURRENT_FILTERS](state, { documentsListFilters }) {
    state.documentsListFilters = documentsListFilters;
  },
  [SET_CURRENT_LOADING](state, { loading }) {
    state.loading = loading;
  },
  [SET_CURRENT_OPTIONS](state, { options }) {
    state.options = options;
  },
  [SET_ITEMS_LENGTH](state, { itemsLength }) {
    state.documentsListItemsLength = itemsLength;
  },
  [SET_DICT_BOOL_STATES](state, { dictBoolStates }) {
    state.documentsListDictBool['states'] = dictBoolStates;
  },
  [SET_DICT_BOOL_TAGS](state, { dictBoolTags }) {
    state.documentsListDictBool['tags'] = dictBoolTags;
  },
  [SET_FILTERS_LOADED](state, { filtersLoaded }) {
    state.documentsListFiltersLoaded = filtersLoaded;
  },
  [SET_MAIN_FILTERS](state, { mainfilters }) {
    state.documentMainFilters = mainfilters;
  },
  [SET_FILTERS_DATA_STATES_VALUES](state, { filtersDataStatesValues }) {
    // state.documentListFiltersData[1].values = filtersDataStatesValues;
    state.documentListFiltersData2['state'].values = filtersDataStatesValues;
  },
  [SET_FILTERS_DATA_TAGS_VALUES](state, { filtersDataTagsValues }) {
    // state.documentListFiltersData[3].values = filtersDataTagsValues;
    state.documentListFiltersData2['tags'].values = filtersDataTagsValues;
  },
  [SET_FILTERS_DATA_EJERCICIO_VALUE](state, { filtersDataEjercicioValue }) {
    state.documentListFiltersData2['ejercicio'].value  = filtersDataEjercicioValue;
  },
  [SET_FILTERS_DATA_PROJECT_VALUE](state, { filtersDataProjectValue }) {
    state.documentListFiltersData2['project'].value  = filtersDataProjectValue;
  },
  [SET_FILTERS_DATA_ID_VALUE](state, { filtersDataIdValue }) {
    state.documentListFiltersData2['id'].value = filtersDataIdValue;
  },
  [SET_FILTERS_DATA_STATE_VALUE](state, { filtersDataStateValue }) {
    // state.documentListFiltersData[1].value = filtersDataStateValue;
    state.documentListFiltersData2['state'].value = filtersDataStateValue;
  },
  [SET_FILTERS_DATA_SEARCH_VALUE](state, { filtersDataSearchValue }) {
    // state.documentListFiltersData[2].value = filtersDataSearchValue;
    state.documentListFiltersData2['search__icontains'].value = filtersDataSearchValue;
  },
  [SET_FILTERS_DATA_SEARCH_DUPLICATE_VALUE](state, { filtersDataSearchDuplicateValue }) {
    state.documentListFiltersData2['search__duplicate'].value = filtersDataSearchDuplicateValue;
  },
  [SET_FILTERS_DATA_TAGS_VALUE](state, { filtersDataTagsValue }) {
    // state.documentListFiltersData[3].value = filtersDataTagsValue;
    state.documentListFiltersData2['tags'].value = filtersDataTagsValue;
  },
  [SET_FILTERS_DATA_ENTRY_NUMBER_VALUE](state, { filtersDataEntryNumberValue }) {
    // state.documentListFiltersData[4].value = filtersDataEntryNumberValue;
  },
  [SET_FILTERS_DATA_ACCOUNT_MOVE_NUMBER_VALUE](state, { filtersDataAccountMoveNumberValue }) {
    // state.documentListFiltersData[5].value = filtersDataAccountMoveNumberValue;
  },
  [SET_FILTERS_DATA_ACTIVIDAD_STR_VALUES](state, { filtersDataActividadStrValues }) {
    state.documentListFiltersData2['actividad_str'].values = filtersDataActividadStrValues;
  },
  [SET_FILTERS_DATA_ACTIVIDAD_VALUES](state, { filtersDataActividadValues }) {
    state.documentListFiltersData2['actividad'].values = filtersDataActividadValues;
  },
  [SET_FILTERS_DATA_KEY](state, {key, value}) { 
    state.documentListFiltersData2[key].value = value;
  },
  [SET_IS_TRAINER_MODE](state, { isTrainerMode }) {
    state.documentIsTrainerMode = isTrainerMode;
  },
  [SET_IS_DEBUGGER_MODE](state, { isDebuggerMode }) {
    state.documentIsDebuggerMode = isDebuggerMode;
  },
  [SET_FORCED_MOVE](state, forced_move) {
    state.document.forced_move = forced_move;
    if(!forced_move){
      state.document.accountMoves=[]
    }
  },
  [SET_ACCOUNT_MOVES](state, account_moves) {
    state.docWriteLoading = false;
    state.document.accountMoves = account_moves;
  },
  [SET_CHECK_SUM](state, { check }) {
    state.checkSumOK = check;
  },
  [SET_ANNOTATION_LAYER](state, str) {
    state.annotationLayer = str;
  },
  [SET_ZOOM](state, zoom) {
    state.zoom = zoom;
  },
  [SET_ROTATION](state, bool) {
    state.inRotationMode = bool;
  },
  [SET_ROTATION_MODE](state, mode) {
    state.rotationMode = mode;
  },
  [SET_GLOBAL_ROTATION](state, rotation) {
    state.globalRotation += rotation;
  },
  [SET_DOCUMENT_ROTATION](state, {page, rotation}) {
    if (!state.rotationPerDocument[page]) {
      state.rotationPerDocument[page] = rotation
    } else {
      state.rotationPerDocument[page] += rotation
    }
    state.rotationPerDocument = [...state.rotationPerDocument];
  },
  [CANCEL_ROTATION](state) {
    state.inRotationMode = false;
    state.rotationMode = 'all';
    state.globalRotation = 0;
    state.rotationPerDocument = [];
  },
  [SET_ROTATION_TASK](state, jobId) {
    state.rotateJobId = jobId;
  },
  [SET_DIRTY](state) {
    state.dirty = true;
  },

  [SET_IVA_0_FROM_TO](state, {from, to}) { // from vat_0 to vat_ns_0
    state.document.metadata = {...state.document.metadata,['base_' + to]:  state.document.metadata['base_' + from]}   
    state.document.metadata = {...state.document.metadata,[to]:  state.document.metadata[from]}  
    state.document.metadata = {...state.document.metadata,['base_' + from]:  ''}   
    state.document.metadata = {...state.document.metadata,[from]:  ''}  
  },

  [SET_INTRA_DATA_FROM_SUPPLIER](state, {thirddb_info, set_flag_bien_inversion, set_account_metadata, feature_default_project_channel_in_third, actividad_kind, feature_extra_supplier}) {
    const capitalGoodsPrefixes = ['52', '17'];
    const supplierAccountPrefix = thirddb_info.credit_account && thirddb_info.credit_account.slice(0, 2);
    state.document.inversion_sujeto_pasivo_iva = thirddb_info.inversion_sujeto_pasivo_iva;
    state.document.inversion_sujeto_pasivo_iva_percent = thirddb_info.inversion_sujeto_pasivo_iva_percent;
    state.document.inversion_sujeto_pasivo_igic = thirddb_info.inversion_sujeto_pasivo_igic;
    state.document.inversion_sujeto_pasivo_igic_percent = thirddb_info.inversion_sujeto_pasivo_igic_percent;
    state.document.intracomunitario = thirddb_info.intracomunitario;
    state.document.intracomunitario_percent = thirddb_info.intracomunitario_percent;
    state.document.intracomunitario_type = thirddb_info.intracomunitario_type;
    if(feature_extra_supplier)
      state.document.extracomunitario = thirddb_info.extracomunitario;
    state.document.no_sujeta = thirddb_info.no_sujeta;
    state.document.importaciones_percent = thirddb_info.importaciones_percent;
    state.document.prorate = thirddb_info.prorate;
    state.document.is_comerciante_minorista_percent = thirddb_info.is_comerciante_minorista_percent;
    state.document.is_comerciante_minorista = thirddb_info.is_comerciante_minorista;
    if (thirddb_info.default_actividad) {
      if (actividad_kind == 'actividad') {
        state.document.actividad = thirddb_info.default_actividad;
      }
      else if (actividad_kind == 'actividad_str') {
        state.document.actividad_str = thirddb_info.default_actividad;
      }
    }
    if(feature_default_project_channel_in_third){
      if (thirddb_info.default_project) {
        state.document.project = thirddb_info.default_project;
      }
      if (thirddb_info.default_channel) {
        state.document.channel = thirddb_info.default_channel;
      }
    }
    if (thirddb_info.default_expens_income_type) {
      state.document.expens_income_type = thirddb_info.default_expens_income_type;
      for (let i in state.document.metadata) {
        if (i.includes('eit_')) {
          state.document.metadata[i] = thirddb_info.default_expens_income_type;
        }
      }
    }
    state.document.building_code = thirddb_info.building_code;
    //Refresh Iva check radiobuttons
    state.document.iva_igic_no_deducible = (thirddb_info.iva_igic_no_deducible || state.document.companydb_info.iva_igic_no_deducible);
    state.document.gasto_iva_parcial = thirddb_info.gasto_iva_parcial;
    state.document.iva_parcial = thirddb_info.iva_parcial;
    state.selectedIvaCheck = undefined;
    state.document.gasto_iva_percent = thirddb_info.gasto_iva_percent;
    state.document.comerciante_minorista = state.document.companydb_info.comerciante_minorista;

    // Calcular si la factura corresponde a un bien de inversión según tipo de cuenta
    if(set_flag_bien_inversion){
      if (supplierAccountPrefix && capitalGoodsPrefixes.includes(supplierAccountPrefix)) {
        state.document.bien_inversion = true
      } else {
        state.document.bien_inversion = false
      }
    }

    if(set_account_metadata){
      if(thirddb_info.expens_accounts && thirddb_info.expens_accounts.length){
        let third_concept = thirddb_info.expens_accounts[0];
        if(state.document.bien_inversion) {
          third_concept = thirddb_info.expens_account_bien_inversion;
        }
        state.document.metadata = {...state.document.metadata,
                                    ['third_concept']: third_concept}    
      }
      else if( thirddb_info.income_accounts && thirddb_info.income_accounts.length){ //actually customer invoices use this mutation too
        state.document.metadata = {...state.document.metadata,
                                  ['third_concept']:thirddb_info.income_accounts[0]}
      }
      else{
        state.document.metadata['third_concept'] = ''
      }
    }
  },
  [SET_CRITERIO_DE_CAJA](state, criterio_de_caja) {
    state.document.criterio_de_caja = criterio_de_caja;
  },
  [SET_IS_COMERCIANTE_MINORISTA](state, is_comerciante_minorista) {
    state.document.is_comerciante_minorista = is_comerciante_minorista;
  },
  [SET_INV_NUMBER_TO_RECTIFY](state, inv_number_to_rectify) {
    state.document.inv_number_to_rectify = inv_number_to_rectify;
  },
  [SET_INV_DATE_TO_RECTIFY](state, inv_date_to_rectify) {
    state.document.inv_date_to_rectify = inv_date_to_rectify;
  },
//   export const SET_INV_NUMBER_TO_RECTIFY = 'SET_INV_NUMBER_TO_RECTIFY';
// export const SET_INV_DATE_TO_RECTIFY = 'SET_INV_DATE_TO_RECTIFY'
// inv_number_to_rectify
//     inv_date_to_rectify
  [SET_INTRA_DATA_FROM_CUSTOM](state, {param, value, value2}) {
    const bool_to_value = {
      inversion_sujeto_pasivo_iva: ['inversion_sujeto_pasivo_iva_percent'],
      inversion_sujeto_pasivo_igic: ['inversion_sujeto_pasivo_igic_percent'],
      intracomunitario: ['intracomunitario_percent', 'intracomunitario_type'],
      extracomunitario: ['importaciones_percent', 'intracomunitario_type'], 
      is_comerciante_minorista: ['is_comerciante_minorista_percent'],
    }
    state.document.inversion_sujeto_pasivo_iva = false;
    state.document.inversion_sujeto_pasivo_iva_percent = "vat_21";
    state.document.inversion_sujeto_pasivo_igic = false;
    state.document.inversion_sujeto_pasivo_igic_percent = "igic_7";
    state.document.intracomunitario = false;
    state.document.intracomunitario_percent = "vat_21";
    state.document.intracomunitario_type = "bienes";
    state.document.extracomunitario = false;
    state.document.importaciones_percent = "vat_21";
    state.document.no_sujeta = false;
    state.document.is_comerciante_minorista = false;
    state.document.is_comerciante_minorista_percent = "igic_7";
    if(param){
      state.document[param] = true;
      if (state.document[param]) {
        if (value) {
          state.document[bool_to_value[param][0]] = value;
        }
        if (value2) {
          state.document[bool_to_value[param][1]] = value2;
        }
        
      }
      // console.log('FINAL STATE', state)
    }
    if (param.default_expens_income_type) {
      state.document.expens_income_type = param.default_expens_income_type;
      for (let i in state.document.metadata) {
        if (i.includes('eit_')) {
          state.document.metadata[i] = param.default_expens_income_type;
        }
      }
    }
  },

  [SET_ITEMS_PER_PAGE](state, itemsPerPage) {
    state.itemsPerPage = itemsPerPage;
  },

  [SET_CURRENT_DOCUMENT_SUPPLIERDB](state, { currentDocumentSupplierdb, currentDocumentSupplierdbInfo, isBienInversionChanged, areIvaChecksChanged }) {
    state.document.supplierdb = currentDocumentSupplierdb;
    state.document.supplierdb_info = currentDocumentSupplierdbInfo;
    if(isBienInversionChanged){
      state.document.bien_inversion = currentDocumentSupplierdbInfo.bien_inversion;
    }

    if (areIvaChecksChanged) {
      state.document.iva_igic_no_deducible = currentDocumentSupplierdbInfo.iva_igic_no_deducible;
      state.document.gasto_iva_parcial = currentDocumentSupplierdbInfo.gasto_iva_parcial;
      state.document.iva_parcial = currentDocumentSupplierdbInfo.iva_parcial;
      state.selectedIvaCheck = undefined;
      state.document.gasto_iva_percent = currentDocumentSupplierdbInfo.gasto_iva_percent;
      state.document.comerciante_minorista = false;
      state.document.prorate = currentDocumentSupplierdbInfo.prorate;
      if (state.document.iva_igic_no_deducible) {
        state.selectedIvaCheck = 'iva_igic_no_deducible';
      }
      else if (state.document.gasto_iva_parcial) {
        state.selectedIvaCheck = 'gasto_iva_parcial';
      }
      else if (state.document.iva_parcial) {
        state.selectedIvaCheck = 'iva_parcial';
      }
      else if (state.document.prorate) {
        state.selectedIvaCheck = 'prorate';
      }
    }
    if (currentDocumentSupplierdbInfo.default_actividad) {
      state.document.actividad_str = currentDocumentSupplierdbInfo.default_actividad;
    }
    if (currentDocumentSupplierdbInfo.default_project) {
      state.document.project = currentDocumentSupplierdbInfo.default_project;
    }
    if (currentDocumentSupplierdbInfo.default_channel) {
      state.document.channel = currentDocumentSupplierdbInfo.default_channel;
    }
    state.document.building_code = currentDocumentSupplierdbInfo.building_code;
    state.document.retention_type_name = currentDocumentSupplierdbInfo.retention_type;
    state.dirty = true;
  },

  [SET_CURRENT_DOCUMENT_CUSTOMERDB](state, { currentDocumentCustomerdb, currentDocumentCustomerdbInfo }) {
    state.document.customerdb = currentDocumentCustomerdb;
    state.document.customerdb_info = currentDocumentCustomerdbInfo;

    if (currentDocumentCustomerdbInfo.default_actividad) {
      state.document.actividad_str = currentDocumentCustomerdbInfo.default_actividad;
    }
    if (currentDocumentCustomerdbInfo.default_project) {
      state.document.project = currentDocumentCustomerdbInfo.default_project;
    }
    if (currentDocumentCustomerdbInfo.default_channel) {
      state.document.channel = currentDocumentCustomerdbInfo.default_channel;
    }
    state.document.retention_type_name = currentDocumentCustomerdbInfo.retention_type;
    state.dirty = true;
  },
  [SET_DOCUMENTS_LIST_HEADERS_USER](state, docListHeadersUser) {
    state.documentListHeadersUser = docListHeadersUser;
  },
  [SET_DOCUMENT_LIST_HIDDEN_HEADERS_USER](state, docListHeadersUser) {
    state.documentListHiddenHeadersUser = docListHeadersUser;
  },
  [SET_DOCUMENTS_LIST_HEADERS](state, docListHeaders) {
    state.documentListHeaders = docListHeaders;
  },

  [SET_DOCUMENT_LIST_HIDDEN_HEADERS](state, docListHeaders) {
    state.documentListHiddenHeaders = docListHeaders;
  },

  [SET_DOCUMENTS_LIST_HEADERS_READ_ONLY](state, docListHeaders) {
    state.documentListHeadersReadOnly = docListHeaders;
  },

  [SET_DOCUMENT_LIST_HIDDEN_HEADERS_READ_ONLY](state, docListHeaders) {
    state.documentListHiddenHeadersReadOnly = docListHeaders;
  },

  [SET_SUPPLIERDB_LIST_HEADERS_USER](state, supListHeadersUser) {
    state.supplierdbListHeadersUser = supListHeadersUser;
  },
  [SET_SUPPLIERDB_LIST_HIDDEN_HEADERS_USER](state, supListHeadersUser) {
    state.supplierdbListHiddenHeadersUser = supListHeadersUser;
  },

  [SET_CUSTOMERDB_LIST_HEADERS_USER](state, cusListHeadersUser) {
    state.customerdbListHeadersUser = cusListHeadersUser;
  },
  [SET_CUSTOMERDB_LIST_HIDDEN_HEADERS_USER](state, cusListHeadersUser) {
    state.customerdbListHiddenHeadersUser = cusListHeadersUser;
  },

  [REMOVE_DOCUMENTS_LIST_HEADERS_ELEM_BY_INDEX](state, index) {
    state.documentListHeaders.splice(index, 1);
  },

  [SET_DOCUMENTS_LIST_HEADERS_ELEM](state, elem) {
    // state.documentListHeaders.push(elem);
    state.documentListHeaders.splice(3, 0, elem);
  },

  [CLEAN_FILTERS](state) {
    for (let i in state.documentListFiltersData2) {
      state.documentListFiltersData2[i].value = '';
    }
    
  },
  [SET_DOCUMENT_OPTIONS_PAGE](state, page) {
    state.documentListOptions['page'] = page;
  },
  [SET_DOCUMENT_LIST_OPTIONS](state, documentListOptions) {
    state.documentListOptions = documentListOptions;
  },
  [SET_DOCUMENT_KIND](state, kind) {
    state.dpcumentListKind = kind;
    state.documentListFiltersData2['kind'].value = kind;
  },
  [SET_STATES_FILTER](state, statesFilter) {
    state.statesFilter = statesFilter;
  },
  [SET_DOCUMENTS_LIST_ID](state, documentsListId) {
    state.documentsListId = documentsListId
  },
  [SET_BROWSER_VALUE](state, {key, value}) {
    if(key=='ejercicio' && value){
      value = parseInt(value)
    }
    state.documentListFiltersData2[key].value = value;
  },
  [UNSELECT_DOCUMENTS](state) {
    state.selected = [];
  },
  [SET_CURRENT_PAGE](state, num) {
    state.currentPage = num;
  },
  [SET_SELECTED_STATE_CHIP](state, value) {
    state.selectedStateChip = value;
  },
  [SET_DOCUMENT_ACTIONS_ERROR_PARAMS](state, value) {
    state.documentActionsErrorParams = value;
  },

  [SET_PAYMENT_ACCOUNT](state, value) {
    state.document.payment_account = value
  },

  [SET_CHARGE_ACCOUNT](state, value) {
    state.document.charge_account = value
  },

  [SET_ACCOUNT_MOVE_LINES](state, { min_footer, footer_height }) {
    state.linesAccountMove.min_footer = min_footer;
    state.linesAccountMove.footer_height = footer_height;
  },
  [SET_LAST_SHOW_ACCOUNT_MOVE](state, option) {
    state.linesAccountMove.last_option.show = option;
  },

  [SET_INVOICE_LINES](state, { show_invoice_lines, footer_height }) {
    state.invoiceLines.show_invoice_lines = show_invoice_lines;
    //state.invoiceLines.footer_height = footer_height;
    state.invoiceLines.invoice_lines_height = footer_height;
  },
  [SET_LAST_SHOW_INVOICE_LINES](state, option) {
    state.invoiceLines.last_option.show = option;
  },

  // Barra de filtros nueva
  [SET_FILTER_EJERCICIO](state, {value, text}) {
    state.documentListFiltersData2['ejercicio'].value = value;
    state.documentListFiltersData2['ejercicio'].text = text;
  },
  [SET_FILTERS_DATA_EJERCICIO_USER_VALUES](state, { filtersDataEjercicioUserValues }) {
    state.documentListFiltersData2['ejercicio'].user_values  = filtersDataEjercicioUserValues;
  },
  [SET_FILTER_ID](state, value) {
    state.documentListFiltersData2['id'].value = value;
  },
  [SET_FILTER_STATE](state, {value,text}) {
    state.documentListFiltersData2['state'].value = value;
    state.documentListFiltersData2['state'].text = text;
  },
  [SET_FILTER_SEARCH_ICONTAINS](state, value) {
    state.documentListFiltersData2['search__icontains'].value = value;
  },
  [SET_FILTER_SEARCH_DUPLICATE](state, value) {
    state.documentListFiltersData2['search__duplicate'].value = value;
  },
  [SET_FILTER_DOCUMENT_TEXT_ICONTAINS](state, value) {
    state.documentListFiltersData2['document_text__icontains'].value = value;
  },
  [SET_FILTER_TAGS](state, value) {
    state.documentListFiltersData2['tags'].value = value;
  },
  [SET_FILTER_ACTIVIDAD_STR](state, value) {
    state.documentListFiltersData2['actividad_str'].value = value;
  },
  [SET_FILTER_ACTIVIDAD](state, value) {
    state.documentListFiltersData2['actividad'].value = value;
  },
  [SET_FILTER_USERNAME_ICONTAINS](state, value) {
    state.documentListFiltersData2['username__icontains'].value = value;
  },
  [SET_FILTER_KIND](state, {value,text}) {
    state.documentListFiltersData2['kind'].value = value;
    state.documentListFiltersData2['kind'].text = text;
  },
  [SET_FILTER_CREATED_GTE](state, value) {
    state.documentListFiltersData2['created__gte'].value = value;
  },
  [SET_FILTER_CREATED_LTE](state, value) {
    state.documentListFiltersData2['created__lte'].value = value;
  },
  [SET_FILTER_ACCOUNTING_DATE_GTE](state, value) {
    state.documentListFiltersData2['accounting_date__gte'].value = value;
  },
  [SET_FILTER_ACCOUNTING_DATE_LTE](state, value) {
    state.documentListFiltersData2['accounting_date__lte'].value = value;
  },
  [SET_FILTER_INVOICE_DATE_GTE](state, value) {
    state.documentListFiltersData2['invoice_date__gte'].value = value;
  },
  [SET_FILTER_INVOICE_DATE_LTE](state, value) {
    state.documentListFiltersData2['invoice_date__lte'].value = value;
  },
  [SET_FILTER_THIRD_CIF_ICONTAINS](state, value) {
    state.documentListFiltersData2['third_cif__icontains'].value = value;
  },
  [SET_FILTER_THIRD_NAME_ICONTAINS](state, value) {
    state.documentListFiltersData2['third_name__icontains'].value = value;
  },
  [SET_FILTER_MIRROR_STATE](state, {value,text}) {
    state.documentListFiltersData2['mirror_state'].value = value;
    state.documentListFiltersData2['mirror_state'].text = text;
  },
  [SET_FILTER_PUNTEADO](state, {value, text}) {
    state.documentListFiltersData2['punteado'].value = value;
    state.documentListFiltersData2['punteado'].text = text;
  },
  [SET_FILTER_RECTIFICATIVA](state, {value, text}) {
    state.documentListFiltersData2['is_rectificativa'].value = value;
    state.documentListFiltersData2['is_rectificativa'].text = text;
  },
  [SET_FILTER_PAYMENT_STATE](state, {value,text}) {
    state.documentListFiltersData2['payment_state'].value = value;
    state.documentListFiltersData2['payment_state'].text = text;
  },
  [SET_FILTER_PAYMENT_DATE_GTE](state, value) {
    state.documentListFiltersData2['payment_date__gte'].value = value;
  },
  [SET_FILTER_PAYMENT_DATE_LTE](state, value) {
    state.documentListFiltersData2['payment_date__lte'].value = value;
  },
  [SET_FILTER_HAS_RETENTION](state, {value, text}) {
    state.documentListFiltersData2['has_retention'].value = value;
    state.documentListFiltersData2['has_retention'].text = text;
  },
  [SET_FILTER_NOTES_ICONTAINS](state, value) {
    state.documentListFiltersData2['notes__icontains'].value = value;
  },

  forceMove: (state) => {
    state.document.accountMoves=[
      {
        document:state.document.id,
        account_move_lines:[{
          debit:0.0,
          credit:0.0,
          description:'',
          base:0.0,
          total:0.0,
          line_type:'apunte',
        }]
      }]
    state.document.forced_move=true
  },
  addLine(state){
    let description = getDefaultMoveLineDescription(state.document.accountMoves[0]);
    state.document.accountMoves[0].account_move_lines.push({
      account:'',
      debit:0.0,
      credit:0.0,
      description: description,
      base:0.0,
      total:0.0,
      line_type:'apunte',
      type_iva: '',
    })
  },
  addPaidLine(state) { 
    if(!state.document.accountMoves[0].paid_account_move || state.document.accountMoves[0].paid_account_move.length == 0){
      var paidAccountMove = {
        payment_move: state.document.accountMoves[0].id,
        state: "pending",
        account_move_lines: [],
      }
      state.document.accountMoves[0].paid_account_move.push(paidAccountMove)
    }
    let description = getDefaultMoveLineDescription(state.document.accountMoves[0].paid_account_move[0]);
    var new_move = {
      account:'',
      debit:0.0,
      credit:0.0,
      description: description,
      base:0.0,
      total:0.0,
      line_type:'apunte',
      type_iva: '',
    };

    state.document.accountMoves[0].paid_account_move[0].account_move_lines.push(new_move)    
  },
  deleteLine(state, index){
    state.document.accountMoves[0].account_move_lines.splice(index,1)
  },
  deletePaidLine(state, index){
    if (state.document.accountMoves[0].paid_account_move && state.document.accountMoves[0].paid_account_move.length) {
      state.document.accountMoves[0].paid_account_move[0].account_move_lines.splice(index, 1)
    }
  },
  updateMetadataField(state, field){
    //console.log("updating metadata field:",field.path,field.value)
    state.dirty = true
    if(!state.document.metadata.hasOwnProperty(field.path))
      Vue.set(state.document.metadata, field.path, field.value)

    updateField(state.document.metadata, field)
  },
  updateAccountMoveField(state, field){
    updateField(state.document.accountMoves[0], field)
  },
  updateField(state,field){
    // console.log("updating field:"+field)
    // console.log(field)
    if(!(field.path && ((field.path == "document.retention_type_name" && state.document.retention_type_name == 'third_value') || field.path == 'document.punteado'))){
      state.dirty = true
    }
    updateField(state,field)
  },

}

export function getDefaultMoveLineDescription(accountMoves) {
  let description = '';
  let count_lines = accountMoves.account_move_lines.length;
  if (count_lines > 0) {
    description = accountMoves.account_move_lines[count_lines-1].description;
  }
  return description;
}
export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
  models,
}
